/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 5003:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 6262:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.A = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 9306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4901);
var tryToString = __webpack_require__(6823);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 5548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__(3517);
var tryToString = __webpack_require__(6823);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 3506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPossiblePrototype = __webpack_require__(3925);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 6469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(8227);
var create = __webpack_require__(2360);
var defineProperty = (__webpack_require__(4913).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(1625);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 8551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(34);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = (__webpack_require__(9213).forEach);
var arrayMethodIsStrict = __webpack_require__(4598);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 9617:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5397);
var toAbsoluteIndex = __webpack_require__(5610);
var lengthOfArrayLike = __webpack_require__(6198);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 9213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(6080);
var uncurryThis = __webpack_require__(9504);
var IndexedObject = __webpack_require__(7055);
var toObject = __webpack_require__(8981);
var lengthOfArrayLike = __webpack_require__(6198);
var arraySpeciesCreate = __webpack_require__(1469);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(self);
    var boundFunction = bind(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);
var wellKnownSymbol = __webpack_require__(8227);
var V8_VERSION = __webpack_require__(7388);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 4598:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 4527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var isArray = __webpack_require__(4376);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 7680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 7433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(4376);
var isConstructor = __webpack_require__(3517);
var isObject = __webpack_require__(34);
var wellKnownSymbol = __webpack_require__(8227);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 1469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__(7433);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 4428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(8227);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 4576:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 6955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(2140);
var isCallable = __webpack_require__(4901);
var classofRaw = __webpack_require__(4576);
var wellKnownSymbol = __webpack_require__(8227);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 7740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(9297);
var ownKeys = __webpack_require__(5031);
var getOwnPropertyDescriptorModule = __webpack_require__(7347);
var definePropertyModule = __webpack_require__(4913);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 2211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 2529:
/***/ (function(module) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 6699:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var definePropertyModule = __webpack_require__(4913);
var createPropertyDescriptor = __webpack_require__(6980);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 6980:
/***/ (function(module) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 2278:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var definePropertyModule = __webpack_require__(4913);
var createPropertyDescriptor = __webpack_require__(6980);

module.exports = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};


/***/ }),

/***/ 3640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8551);
var ordinaryToPrimitive = __webpack_require__(4270);

var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw new $TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ 2106:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(283);
var defineProperty = __webpack_require__(4913);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 6840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4901);
var definePropertyModule = __webpack_require__(4913);
var makeBuiltIn = __webpack_require__(283);
var defineGlobalProperty = __webpack_require__(9433);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 9433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 3724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 4055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var isObject = __webpack_require__(34);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 6837:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 7400:
/***/ (function(module) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 9296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(4055);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 7290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_DENO = __webpack_require__(516);
var IS_NODE = __webpack_require__(9088);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ 516:
/***/ (function(module) {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ 28:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(9392);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ 8119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(9392);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 9088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var classof = __webpack_require__(4576);

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ 6765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(9392);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 9392:
/***/ (function(module) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 7388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var userAgent = __webpack_require__(9392);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 8727:
/***/ (function(module) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 6193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(6699);
var clearErrorStack = __webpack_require__(6193);
var ERROR_STACK_INSTALLABLE = __webpack_require__(4659);

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ 4659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);
var createPropertyDescriptor = __webpack_require__(6980);

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ 6518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var getOwnPropertyDescriptor = (__webpack_require__(7347).f);
var createNonEnumerableProperty = __webpack_require__(6699);
var defineBuiltIn = __webpack_require__(6840);
var defineGlobalProperty = __webpack_require__(9433);
var copyConstructorProperties = __webpack_require__(7740);
var isForced = __webpack_require__(2796);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global[TARGET] && global[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 9039:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 8745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(616);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 6080:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(7476);
var aCallable = __webpack_require__(9306);
var NATIVE_BIND = __webpack_require__(616);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 616:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 566:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var aCallable = __webpack_require__(9306);
var isObject = __webpack_require__(34);
var hasOwn = __webpack_require__(9297);
var arraySlice = __webpack_require__(7680);
var NATIVE_BIND = __webpack_require__(616);

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    var list = [];
    var i = 0;
    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ 9565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(616);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var hasOwn = __webpack_require__(9297);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 6706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var aCallable = __webpack_require__(9306);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 7476:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(4576);
var uncurryThis = __webpack_require__(9504);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 9504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(616);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 7751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var isCallable = __webpack_require__(4901);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(6955);
var getMethod = __webpack_require__(5966);
var isNullOrUndefined = __webpack_require__(4117);
var Iterators = __webpack_require__(6269);
var wellKnownSymbol = __webpack_require__(8227);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 81:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var aCallable = __webpack_require__(9306);
var anObject = __webpack_require__(8551);
var tryToString = __webpack_require__(6823);
var getIteratorMethod = __webpack_require__(851);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 6933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var isArray = __webpack_require__(4376);
var isCallable = __webpack_require__(4901);
var classof = __webpack_require__(4576);
var toString = __webpack_require__(655);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 5966:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9306);
var isNullOrUndefined = __webpack_require__(4117);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 4475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 9297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var toObject = __webpack_require__(8981);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 421:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 3138:
/***/ (function(module) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 5917:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var fails = __webpack_require__(9039);
var createElement = __webpack_require__(4055);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 7055:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var fails = __webpack_require__(9039);
var classof = __webpack_require__(4576);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 3167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4901);
var isObject = __webpack_require__(34);
var setPrototypeOf = __webpack_require__(2967);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 3706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var isCallable = __webpack_require__(4901);
var store = __webpack_require__(7629);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 7584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(34);
var createNonEnumerableProperty = __webpack_require__(6699);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ 1181:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(8622);
var global = __webpack_require__(4475);
var isObject = __webpack_require__(34);
var createNonEnumerableProperty = __webpack_require__(6699);
var hasOwn = __webpack_require__(9297);
var shared = __webpack_require__(7629);
var sharedKey = __webpack_require__(6119);
var hiddenKeys = __webpack_require__(421);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 4209:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(8227);
var Iterators = __webpack_require__(6269);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 4376:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(4576);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 4901:
/***/ (function(module) {

"use strict";

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 3517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);
var classof = __webpack_require__(6955);
var getBuiltIn = __webpack_require__(7751);
var inspectSource = __webpack_require__(3706);

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 2796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 4117:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 34:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(4901);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 3925:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(34);

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};


/***/ }),

/***/ 6395:
/***/ (function(module) {

"use strict";

module.exports = false;


/***/ }),

/***/ 757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);
var isCallable = __webpack_require__(4901);
var isPrototypeOf = __webpack_require__(1625);
var USE_SYMBOL_AS_UID = __webpack_require__(7040);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 2652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(6080);
var call = __webpack_require__(9565);
var anObject = __webpack_require__(8551);
var tryToString = __webpack_require__(6823);
var isArrayIteratorMethod = __webpack_require__(4209);
var lengthOfArrayLike = __webpack_require__(6198);
var isPrototypeOf = __webpack_require__(1625);
var getIterator = __webpack_require__(81);
var getIteratorMethod = __webpack_require__(851);
var iteratorClose = __webpack_require__(9539);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 9539:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var anObject = __webpack_require__(8551);
var getMethod = __webpack_require__(5966);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 3994:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = (__webpack_require__(7657).IteratorPrototype);
var create = __webpack_require__(2360);
var createPropertyDescriptor = __webpack_require__(6980);
var setToStringTag = __webpack_require__(687);
var Iterators = __webpack_require__(6269);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 1088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var call = __webpack_require__(9565);
var IS_PURE = __webpack_require__(6395);
var FunctionName = __webpack_require__(350);
var isCallable = __webpack_require__(4901);
var createIteratorConstructor = __webpack_require__(3994);
var getPrototypeOf = __webpack_require__(2787);
var setPrototypeOf = __webpack_require__(2967);
var setToStringTag = __webpack_require__(687);
var createNonEnumerableProperty = __webpack_require__(6699);
var defineBuiltIn = __webpack_require__(6840);
var wellKnownSymbol = __webpack_require__(8227);
var Iterators = __webpack_require__(6269);
var IteratorsCore = __webpack_require__(7657);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 7657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);
var isObject = __webpack_require__(34);
var create = __webpack_require__(2360);
var getPrototypeOf = __webpack_require__(2787);
var defineBuiltIn = __webpack_require__(6840);
var wellKnownSymbol = __webpack_require__(8227);
var IS_PURE = __webpack_require__(6395);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 6269:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 6198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(8014);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);
var hasOwn = __webpack_require__(9297);
var DESCRIPTORS = __webpack_require__(3724);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(350).CONFIGURABLE);
var inspectSource = __webpack_require__(3706);
var InternalStateModule = __webpack_require__(1181);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 741:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 1955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var safeGetBuiltIn = __webpack_require__(3389);
var bind = __webpack_require__(6080);
var macrotask = (__webpack_require__(9225).set);
var Queue = __webpack_require__(8265);
var IS_IOS = __webpack_require__(8119);
var IS_IOS_PEBBLE = __webpack_require__(28);
var IS_WEBOS_WEBKIT = __webpack_require__(6765);
var IS_NODE = __webpack_require__(9088);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
var microtask = safeGetBuiltIn('queueMicrotask');
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ 6043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9306);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 2603:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__(655);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 2360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(8551);
var definePropertiesModule = __webpack_require__(6801);
var enumBugKeys = __webpack_require__(8727);
var hiddenKeys = __webpack_require__(421);
var html = __webpack_require__(397);
var documentCreateElement = __webpack_require__(4055);
var sharedKey = __webpack_require__(6119);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 6801:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8686);
var definePropertyModule = __webpack_require__(4913);
var anObject = __webpack_require__(8551);
var toIndexedObject = __webpack_require__(5397);
var objectKeys = __webpack_require__(1072);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 4913:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var IE8_DOM_DEFINE = __webpack_require__(5917);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(8686);
var anObject = __webpack_require__(8551);
var toPropertyKey = __webpack_require__(6969);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 7347:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var call = __webpack_require__(9565);
var propertyIsEnumerableModule = __webpack_require__(8773);
var createPropertyDescriptor = __webpack_require__(6980);
var toIndexedObject = __webpack_require__(5397);
var toPropertyKey = __webpack_require__(6969);
var hasOwn = __webpack_require__(9297);
var IE8_DOM_DEFINE = __webpack_require__(5917);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(4576);
var toIndexedObject = __webpack_require__(5397);
var $getOwnPropertyNames = (__webpack_require__(8480).f);
var arraySlice = __webpack_require__(7680);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8480:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(1828);
var enumBugKeys = __webpack_require__(8727);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 3717:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 2787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(9297);
var isCallable = __webpack_require__(4901);
var toObject = __webpack_require__(8981);
var sharedKey = __webpack_require__(6119);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(2211);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 1625:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 1828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var hasOwn = __webpack_require__(9297);
var toIndexedObject = __webpack_require__(5397);
var indexOf = (__webpack_require__(9617).indexOf);
var hiddenKeys = __webpack_require__(421);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(1828);
var enumBugKeys = __webpack_require__(8727);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 8773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 2967:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(6706);
var isObject = __webpack_require__(34);
var requireObjectCoercible = __webpack_require__(7750);
var aPossiblePrototype = __webpack_require__(3506);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 2357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var fails = __webpack_require__(9039);
var uncurryThis = __webpack_require__(9504);
var objectGetPrototypeOf = __webpack_require__(2787);
var objectKeys = __webpack_require__(1072);
var toIndexedObject = __webpack_require__(5397);
var $propertyIsEnumerable = (__webpack_require__(8773).f);

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ 3179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(2140);
var classof = __webpack_require__(6955);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 4270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var isCallable = __webpack_require__(4901);
var isObject = __webpack_require__(34);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 5031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);
var uncurryThis = __webpack_require__(9504);
var getOwnPropertyNamesModule = __webpack_require__(8480);
var getOwnPropertySymbolsModule = __webpack_require__(3717);
var anObject = __webpack_require__(8551);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 9167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);

module.exports = global;


/***/ }),

/***/ 1103:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var NativePromiseConstructor = __webpack_require__(550);
var isCallable = __webpack_require__(4901);
var isForced = __webpack_require__(2796);
var inspectSource = __webpack_require__(3706);
var wellKnownSymbol = __webpack_require__(8227);
var IS_BROWSER = __webpack_require__(7290);
var IS_DENO = __webpack_require__(516);
var IS_PURE = __webpack_require__(6395);
var V8_VERSION = __webpack_require__(7388);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);

module.exports = global.Promise;


/***/ }),

/***/ 3438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8551);
var isObject = __webpack_require__(34);
var newPromiseCapability = __webpack_require__(6043);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 537:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__(550);
var checkCorrectnessOfIteration = __webpack_require__(4428);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(916).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 1056:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(4913).f);

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ 8265:
/***/ (function(module) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 7979:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8551);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 1034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var hasOwn = __webpack_require__(9297);
var isPrototypeOf = __webpack_require__(1625);
var regExpFlags = __webpack_require__(7979);

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ 7750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(4117);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 3389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var DESCRIPTORS = __webpack_require__(3724);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
module.exports = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};


/***/ }),

/***/ 7633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);
var defineBuiltInAccessor = __webpack_require__(2106);
var wellKnownSymbol = __webpack_require__(8227);
var DESCRIPTORS = __webpack_require__(3724);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 687:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(4913).f);
var hasOwn = __webpack_require__(9297);
var wellKnownSymbol = __webpack_require__(8227);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(5745);
var uid = __webpack_require__(3392);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 7629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(6395);
var globalThis = __webpack_require__(4475);
var defineGlobalProperty = __webpack_require__(9433);

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.36.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 5745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var store = __webpack_require__(7629);

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),

/***/ 2293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8551);
var aConstructor = __webpack_require__(5548);
var isNullOrUndefined = __webpack_require__(4117);
var wellKnownSymbol = __webpack_require__(8227);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 8183:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var toIntegerOrInfinity = __webpack_require__(1291);
var toString = __webpack_require__(655);
var requireObjectCoercible = __webpack_require__(7750);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 3802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);
var requireObjectCoercible = __webpack_require__(7750);
var toString = __webpack_require__(655);
var whitespaces = __webpack_require__(7452);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 4495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7388);
var fails = __webpack_require__(9039);
var global = __webpack_require__(4475);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 8242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var getBuiltIn = __webpack_require__(7751);
var wellKnownSymbol = __webpack_require__(8227);
var defineBuiltIn = __webpack_require__(6840);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 1296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(4495);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 9225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var apply = __webpack_require__(8745);
var bind = __webpack_require__(6080);
var isCallable = __webpack_require__(4901);
var hasOwn = __webpack_require__(9297);
var fails = __webpack_require__(9039);
var html = __webpack_require__(397);
var arraySlice = __webpack_require__(7680);
var createElement = __webpack_require__(4055);
var validateArgumentsLength = __webpack_require__(2812);
var IS_IOS = __webpack_require__(8119);
var IS_NODE = __webpack_require__(9088);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 1240:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ 5610:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(1291);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(7055);
var requireObjectCoercible = __webpack_require__(7750);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 1291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(741);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 8014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(1291);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 8981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(7750);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 2777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(9565);
var isObject = __webpack_require__(34);
var isSymbol = __webpack_require__(757);
var getMethod = __webpack_require__(5966);
var ordinaryToPrimitive = __webpack_require__(4270);
var wellKnownSymbol = __webpack_require__(8227);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 6969:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(2777);
var isSymbol = __webpack_require__(757);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(8227);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(6955);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 6823:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 3392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(9504);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 7040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(4495);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 8686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var fails = __webpack_require__(9039);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 2812:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 8622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var isCallable = __webpack_require__(4901);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 511:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(9167);
var hasOwn = __webpack_require__(9297);
var wrappedWellKnownSymbolModule = __webpack_require__(1951);
var defineProperty = (__webpack_require__(4913).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 1951:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(8227);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 8227:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var shared = __webpack_require__(5745);
var hasOwn = __webpack_require__(9297);
var uid = __webpack_require__(3392);
var NATIVE_SYMBOL = __webpack_require__(4495);
var USE_SYMBOL_AS_UID = __webpack_require__(7040);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 7452:
/***/ (function(module) {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 4601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);
var hasOwn = __webpack_require__(9297);
var createNonEnumerableProperty = __webpack_require__(6699);
var isPrototypeOf = __webpack_require__(1625);
var setPrototypeOf = __webpack_require__(2967);
var copyConstructorProperties = __webpack_require__(7740);
var proxyAccessor = __webpack_require__(1056);
var inheritIfRequired = __webpack_require__(3167);
var normalizeStringArgument = __webpack_require__(2603);
var installErrorCause = __webpack_require__(7584);
var installErrorStack = __webpack_require__(747);
var DESCRIPTORS = __webpack_require__(3724);
var IS_PURE = __webpack_require__(6395);

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ 8706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var fails = __webpack_require__(9039);
var isArray = __webpack_require__(4376);
var isObject = __webpack_require__(34);
var toObject = __webpack_require__(8981);
var lengthOfArrayLike = __webpack_require__(6198);
var doesNotExceedSafeInteger = __webpack_require__(6837);
var createProperty = __webpack_require__(2278);
var arraySpeciesCreate = __webpack_require__(1469);
var arrayMethodHasSpeciesSupport = __webpack_require__(597);
var wellKnownSymbol = __webpack_require__(8227);
var V8_VERSION = __webpack_require__(7388);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 2008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var $filter = (__webpack_require__(9213).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(597);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 3792:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5397);
var addToUnscopables = __webpack_require__(6469);
var Iterators = __webpack_require__(6269);
var InternalStateModule = __webpack_require__(1181);
var defineProperty = (__webpack_require__(4913).f);
var defineIterator = __webpack_require__(1088);
var createIterResultObject = __webpack_require__(2529);
var IS_PURE = __webpack_require__(6395);
var DESCRIPTORS = __webpack_require__(3724);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 4114:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var toObject = __webpack_require__(8981);
var lengthOfArrayLike = __webpack_require__(6198);
var setArrayLength = __webpack_require__(4527);
var doesNotExceedSafeInteger = __webpack_require__(6837);
var fails = __webpack_require__(9039);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 4782:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var isArray = __webpack_require__(4376);
var isConstructor = __webpack_require__(3517);
var isObject = __webpack_require__(34);
var toAbsoluteIndex = __webpack_require__(5610);
var lengthOfArrayLike = __webpack_require__(6198);
var toIndexedObject = __webpack_require__(5397);
var createProperty = __webpack_require__(2278);
var wellKnownSymbol = __webpack_require__(8227);
var arrayMethodHasSpeciesSupport = __webpack_require__(597);
var nativeSlice = __webpack_require__(7680);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 9572:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(9297);
var defineBuiltIn = __webpack_require__(6840);
var dateToPrimitive = __webpack_require__(3640);
var wellKnownSymbol = __webpack_require__(8227);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ 6280:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__(6518);
var global = __webpack_require__(4475);
var apply = __webpack_require__(8745);
var wrapErrorConstructorWithCause = __webpack_require__(4601);

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ 2010:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var FUNCTION_NAME_EXISTS = (__webpack_require__(350).EXISTS);
var uncurryThis = __webpack_require__(9504);
var defineBuiltInAccessor = __webpack_require__(2106);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 3110:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var getBuiltIn = __webpack_require__(7751);
var apply = __webpack_require__(8745);
var call = __webpack_require__(9565);
var uncurryThis = __webpack_require__(9504);
var fails = __webpack_require__(9039);
var isCallable = __webpack_require__(4901);
var isSymbol = __webpack_require__(757);
var arraySlice = __webpack_require__(7680);
var getReplacerFunction = __webpack_require__(6933);
var NATIVE_SYMBOL = __webpack_require__(4495);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 4731:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var setToStringTag = __webpack_require__(687);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 479:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var setToStringTag = __webpack_require__(687);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 2892:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var IS_PURE = __webpack_require__(6395);
var DESCRIPTORS = __webpack_require__(3724);
var global = __webpack_require__(4475);
var path = __webpack_require__(9167);
var uncurryThis = __webpack_require__(9504);
var isForced = __webpack_require__(2796);
var hasOwn = __webpack_require__(9297);
var inheritIfRequired = __webpack_require__(3167);
var isPrototypeOf = __webpack_require__(1625);
var isSymbol = __webpack_require__(757);
var toPrimitive = __webpack_require__(2777);
var fails = __webpack_require__(9039);
var getOwnPropertyNames = (__webpack_require__(8480).f);
var getOwnPropertyDescriptor = (__webpack_require__(7347).f);
var defineProperty = (__webpack_require__(4913).f);
var thisNumberValue = __webpack_require__(1240);
var trim = (__webpack_require__(3802).trim);

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw new TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        // fast equal of /^0b[01]+$/i
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0o[0-7]+$/i
        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        default:
          return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),

/***/ 3851:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var fails = __webpack_require__(9039);
var toIndexedObject = __webpack_require__(5397);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(7347).f);
var DESCRIPTORS = __webpack_require__(3724);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 1278:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var DESCRIPTORS = __webpack_require__(3724);
var ownKeys = __webpack_require__(5031);
var toIndexedObject = __webpack_require__(5397);
var getOwnPropertyDescriptorModule = __webpack_require__(7347);
var createProperty = __webpack_require__(2278);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 9773:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var NATIVE_SYMBOL = __webpack_require__(4495);
var fails = __webpack_require__(9039);
var getOwnPropertySymbolsModule = __webpack_require__(3717);
var toObject = __webpack_require__(8981);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 875:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var fails = __webpack_require__(9039);
var toObject = __webpack_require__(8981);
var nativeGetPrototypeOf = __webpack_require__(2787);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(2211);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 9432:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var toObject = __webpack_require__(8981);
var nativeKeys = __webpack_require__(1072);
var fails = __webpack_require__(9039);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 3548:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(3724);
var defineBuiltInAccessor = __webpack_require__(2106);
var isObject = __webpack_require__(34);
var isPossiblePrototype = __webpack_require__(3925);
var toObject = __webpack_require__(8981);
var requireObjectCoercible = __webpack_require__(7750);

// eslint-disable-next-line es/no-object-getprototypeof -- safe
var getPrototypeOf = Object.getPrototypeOf;
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var setPrototypeOf = Object.setPrototypeOf;
var ObjectPrototype = Object.prototype;
var PROTO = '__proto__';

// `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__
if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
  defineBuiltInAccessor(ObjectPrototype, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf(toObject(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (isPossiblePrototype(proto) && isObject(O)) {
        setPrototypeOf(O, proto);
      }
    }
  });
} catch (error) { /* empty */ }


/***/ }),

/***/ 287:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var setPrototypeOf = __webpack_require__(2967);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ 6099:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(2140);
var defineBuiltIn = __webpack_require__(6840);
var toString = __webpack_require__(3179);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 6034:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var $values = (__webpack_require__(2357).values);

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ 6499:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var call = __webpack_require__(9565);
var aCallable = __webpack_require__(9306);
var newPromiseCapabilityModule = __webpack_require__(6043);
var perform = __webpack_require__(1103);
var iterate = __webpack_require__(2652);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(537);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 2003:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var IS_PURE = __webpack_require__(6395);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(916).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(550);
var getBuiltIn = __webpack_require__(7751);
var isCallable = __webpack_require__(4901);
var defineBuiltIn = __webpack_require__(6840);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 436:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var IS_PURE = __webpack_require__(6395);
var IS_NODE = __webpack_require__(9088);
var global = __webpack_require__(4475);
var call = __webpack_require__(9565);
var defineBuiltIn = __webpack_require__(6840);
var setPrototypeOf = __webpack_require__(2967);
var setToStringTag = __webpack_require__(687);
var setSpecies = __webpack_require__(7633);
var aCallable = __webpack_require__(9306);
var isCallable = __webpack_require__(4901);
var isObject = __webpack_require__(34);
var anInstance = __webpack_require__(679);
var speciesConstructor = __webpack_require__(2293);
var task = (__webpack_require__(9225).set);
var microtask = __webpack_require__(1955);
var hostReportErrors = __webpack_require__(3138);
var perform = __webpack_require__(1103);
var Queue = __webpack_require__(8265);
var InternalStateModule = __webpack_require__(1181);
var NativePromiseConstructor = __webpack_require__(550);
var PromiseConstructorDetection = __webpack_require__(916);
var newPromiseCapabilityModule = __webpack_require__(6043);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 9391:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var IS_PURE = __webpack_require__(6395);
var NativePromiseConstructor = __webpack_require__(550);
var fails = __webpack_require__(9039);
var getBuiltIn = __webpack_require__(7751);
var isCallable = __webpack_require__(4901);
var speciesConstructor = __webpack_require__(2293);
var promiseResolve = __webpack_require__(3438);
var defineBuiltIn = __webpack_require__(6840);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ 3362:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(436);
__webpack_require__(6499);
__webpack_require__(2003);
__webpack_require__(7743);
__webpack_require__(1481);
__webpack_require__(280);


/***/ }),

/***/ 7743:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var call = __webpack_require__(9565);
var aCallable = __webpack_require__(9306);
var newPromiseCapabilityModule = __webpack_require__(6043);
var perform = __webpack_require__(1103);
var iterate = __webpack_require__(2652);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(537);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 1481:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var newPromiseCapabilityModule = __webpack_require__(6043);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(916).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});


/***/ }),

/***/ 280:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var getBuiltIn = __webpack_require__(7751);
var IS_PURE = __webpack_require__(6395);
var NativePromiseConstructor = __webpack_require__(550);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(916).CONSTRUCTOR);
var promiseResolve = __webpack_require__(3438);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 825:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var getBuiltIn = __webpack_require__(7751);
var apply = __webpack_require__(8745);
var bind = __webpack_require__(566);
var aConstructor = __webpack_require__(5548);
var anObject = __webpack_require__(8551);
var isObject = __webpack_require__(34);
var create = __webpack_require__(2360);
var fails = __webpack_require__(9039);

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target === newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ 8781:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(350).PROPER);
var defineBuiltIn = __webpack_require__(6840);
var anObject = __webpack_require__(8551);
var $toString = __webpack_require__(655);
var fails = __webpack_require__(9039);
var getRegExpFlags = __webpack_require__(1034);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ 7764:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(8183).charAt);
var toString = __webpack_require__(655);
var InternalStateModule = __webpack_require__(1181);
var defineIterator = __webpack_require__(1088);
var createIterResultObject = __webpack_require__(2529);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ 6412:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(511);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 6761:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var global = __webpack_require__(4475);
var call = __webpack_require__(9565);
var uncurryThis = __webpack_require__(9504);
var IS_PURE = __webpack_require__(6395);
var DESCRIPTORS = __webpack_require__(3724);
var NATIVE_SYMBOL = __webpack_require__(4495);
var fails = __webpack_require__(9039);
var hasOwn = __webpack_require__(9297);
var isPrototypeOf = __webpack_require__(1625);
var anObject = __webpack_require__(8551);
var toIndexedObject = __webpack_require__(5397);
var toPropertyKey = __webpack_require__(6969);
var $toString = __webpack_require__(655);
var createPropertyDescriptor = __webpack_require__(6980);
var nativeObjectCreate = __webpack_require__(2360);
var objectKeys = __webpack_require__(1072);
var getOwnPropertyNamesModule = __webpack_require__(8480);
var getOwnPropertyNamesExternal = __webpack_require__(298);
var getOwnPropertySymbolsModule = __webpack_require__(3717);
var getOwnPropertyDescriptorModule = __webpack_require__(7347);
var definePropertyModule = __webpack_require__(4913);
var definePropertiesModule = __webpack_require__(6801);
var propertyIsEnumerableModule = __webpack_require__(8773);
var defineBuiltIn = __webpack_require__(6840);
var defineBuiltInAccessor = __webpack_require__(2106);
var shared = __webpack_require__(5745);
var sharedKey = __webpack_require__(6119);
var hiddenKeys = __webpack_require__(421);
var uid = __webpack_require__(3392);
var wellKnownSymbol = __webpack_require__(8227);
var wrappedWellKnownSymbolModule = __webpack_require__(1951);
var defineWellKnownSymbol = __webpack_require__(511);
var defineSymbolToPrimitive = __webpack_require__(8242);
var setToStringTag = __webpack_require__(687);
var InternalStateModule = __webpack_require__(1181);
var $forEach = (__webpack_require__(9213).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = global.RangeError;
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      var $this = this === undefined ? global : this;
      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 9463:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(6518);
var DESCRIPTORS = __webpack_require__(3724);
var global = __webpack_require__(4475);
var uncurryThis = __webpack_require__(9504);
var hasOwn = __webpack_require__(9297);
var isCallable = __webpack_require__(4901);
var isPrototypeOf = __webpack_require__(1625);
var toString = __webpack_require__(655);
var defineBuiltInAccessor = __webpack_require__(2106);
var copyConstructorProperties = __webpack_require__(7740);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var getBuiltIn = __webpack_require__(7751);
var hasOwn = __webpack_require__(9297);
var toString = __webpack_require__(655);
var shared = __webpack_require__(5745);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(1296);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 2259:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(511);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 2675:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(6761);
__webpack_require__(1510);
__webpack_require__(7812);
__webpack_require__(3110);
__webpack_require__(9773);


/***/ }),

/***/ 7812:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(6518);
var hasOwn = __webpack_require__(9297);
var isSymbol = __webpack_require__(757);
var tryToString = __webpack_require__(6823);
var shared = __webpack_require__(5745);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(1296);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 5700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(511);
var defineSymbolToPrimitive = __webpack_require__(8242);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),

/***/ 8125:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(7751);
var defineWellKnownSymbol = __webpack_require__(511);
var setToStringTag = __webpack_require__(687);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ 3500:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var DOMIterables = __webpack_require__(7400);
var DOMTokenListPrototype = __webpack_require__(9296);
var forEach = __webpack_require__(235);
var createNonEnumerableProperty = __webpack_require__(6699);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 2953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4475);
var DOMIterables = __webpack_require__(7400);
var DOMTokenListPrototype = __webpack_require__(9296);
var ArrayIteratorMethods = __webpack_require__(3792);
var createNonEnumerableProperty = __webpack_require__(6699);
var setToStringTag = __webpack_require__(687);
var wellKnownSymbol = __webpack_require__(8227);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ApiView: function() { return /* reexport */ ApiView; },
  BlockingApi: function() { return /* reexport */ blockingApi; },
  BookingApi: function() { return /* reexport */ bookingApi; },
  ClubsApi: function() { return /* reexport */ clubsApi; },
  CountriesApi: function() { return /* reexport */ countriesApi; },
  FeeApi: function() { return /* reexport */ feeApi; },
  GreenCardApi: function() { return /* reexport */ greenCardApi; },
  GroupBookingApi: function() { return /* reexport */ groupBookingApi; },
  HcpApi: function() { return /* reexport */ hcpApi; },
  HolidaysApi: function() { return /* reexport */ holidaysApi; },
  MessagesApi: function() { return /* reexport */ messagesApi; },
  PersonsApi: function() { return /* reexport */ personsApi; },
  RentalItemApi: function() { return /* reexport */ rentalItemApi; },
  ScheduleApi: function() { return /* reexport */ scheduleApi; },
  ScoreCardApi: function() { return /* reexport */ scoreCardApi; },
  ServiceBase: function() { return /* reexport */ serviceBase; },
  SlotBookingApi: function() { return /* reexport */ slotBookingApi; },
  TeeApi: function() { return /* reexport */ teeApi; },
  TeeTimeApi: function() { return /* reexport */ teeTimeApi; },
  UserApi: function() { return /* reexport */ userApi; },
  actions: function() { return /* reexport */ actions; },
  apiStore: function() { return /* reexport */ apiStore; },
  apiTypes: function() { return /* reexport */ apiStore_types; },
  getters: function() { return /* reexport */ getters; },
  mutations: function() { return /* reexport */ apiStore_mutations; },
  state: function() { return /* reexport */ apiStore_state; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(5003)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./src/apiStore/state.js
var state = {
  baseUrl: "",
  loaders: {},
  errors: {}
};
/* harmony default export */ var apiStore_state = (state);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(2675);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(9463);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(2259);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(3792);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(6099);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(7764);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(2953);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(5700);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(6280);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(9572);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(2892);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js





function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(6034);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(825);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(875);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.proto.js
var es_object_proto = __webpack_require__(3548);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(287);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js



function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/callSuper.js




function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js


function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: external "@sgf/go-utilities"
var go_utilities_namespaceObject = require("@sgf/go-utilities");
;// CONCATENATED MODULE: ./src/apiStore/types.js






var ApiTypes = /*#__PURE__*/function (_TypesBase) {
  function ApiTypes() {
    var _this;
    _classCallCheck(this, ApiTypes);
    _this = _callSuper(this, ApiTypes, ['api']);
    _defineProperty(_this, "getters", {
      OPTIONS: 'options',
      GET_LOADER: 'getLoader',
      GET_ERROR: 'getError',
      GET_ERRORS: 'getErrors'
    });
    _defineProperty(_this, "actions", {
      HANDLE_ERROR: 'handleError',
      SET_LOADER: 'setLoader',
      SET_ERROR: 'setError',
      CLEAR_ERROR: 'clearError'
    });
    _defineProperty(_this, "mutations", {
      SET_LOADER: 'setLoader',
      SET_ERROR: 'setError',
      CLEAR_ERROR: 'clearError'
    });
    return _this;
  }
  _inherits(ApiTypes, _TypesBase);
  return _createClass(ApiTypes);
}(go_utilities_namespaceObject.TypesBase);
var NamespacedApiTypes = /*#__PURE__*/function (_ApiTypes2) {
  function NamespacedApiTypes() {
    var _this2;
    _classCallCheck(this, NamespacedApiTypes);
    _this2 = _callSuper(this, NamespacedApiTypes);
    _this2.toNamespaced();
    return _this2;
  }
  _inherits(NamespacedApiTypes, _ApiTypes2);
  return _createClass(NamespacedApiTypes);
}(ApiTypes);
var types = new NamespacedApiTypes();
var _types = new ApiTypes();

/* harmony default export */ var apiStore_types = (types);
;// CONCATENATED MODULE: ./src/apiStore/getters.js



/* harmony default export */ var getters = (_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _types.getters.OPTIONS, function (state, getters, rootState, rootGetters) {
  var result = {
    baseUrl: state.baseUrl,
    cache: 'no-cache',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  };
  if (rootGetters['authentication/getUserToken']) {
    result.headers['Authorization'] = "Bearer ".concat(rootGetters['authentication/getUserToken']);
  }
  return result;
}), _types.getters.GET_LOADER, function (state) {
  return function (id) {
    if (!state.loaders[id]) {
      return {
        isActive: false
      };
    }
    return state.loaders[id];
  };
}), _types.getters.GET_ERROR, function (state) {
  return function (id) {
    if (!state.errors[id]) {
      return {
        isActive: false
      };
    }
    return state.errors[id];
  };
}), _types.getters.GET_ERRORS, function (state) {
  var errors = Object.values(state.errors);
  if (errors.length === 0) {
    return {
      isActive: false
    };
  }
  return errors[0];
}));
;// CONCATENATED MODULE: ./src/apiStore/mutations.js


var mutations = _defineProperty(_defineProperty(_defineProperty({}, _types.mutations.SET_LOADER, function (state, payload) {
  if (!payload.isActive) {
    delete state.loaders[payload.correlationId];
  } else {
    state.loaders[payload.correlationId] = payload;
  }
}), _types.mutations.SET_ERROR, function (state, payload) {
  state.errors[payload.correlationId] = payload;
}), _types.mutations.CLEAR_ERROR, function (state, correlationId) {
  delete state.errors[correlationId];
});
/* harmony default export */ var apiStore_mutations = (mutations);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(2008);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(4114);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(3851);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(1278);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(9432);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(3500);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
;// CONCATENATED MODULE: ./src/apiStore/actions.js



/* harmony default export */ var actions = (_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _types.actions.HANDLE_ERROR, function (context, payload) {
  if (payload.code === 401) {
    context.dispatch('authentication/logout', {}, {
      root: true
    });
  } else if (payload.code === 403) {
    context.dispatch(_types.actions.SET_ERROR, {
      correlationId: payload.correlationId,
      message: 'Behörighet saknas.',
      isActive: true
    });
  } else if (payload.code) {
    context.dispatch(_types.actions.SET_ERROR, _objectSpread2(_objectSpread2({}, payload), {}, {
      isActive: true
    }));
  }
}), _types.actions.SET_LOADER, function (context, payload) {
  context.commit(_types.mutations.SET_LOADER, payload);
}), _types.actions.SET_ERROR, function (context, payload) {
  context.commit(_types.mutations.SET_ERROR, payload);
}), _types.actions.CLEAR_ERROR, function (context, correlationId) {
  context.commit(_types.mutations.CLEAR_ERROR, correlationId);
}));
;// CONCATENATED MODULE: ./src/apiStore/index.js






/* harmony default export */ var apiStore = ({
  namespaced: true,
  state: apiStore_state,
  getters: getters,
  actions: actions,
  mutations: apiStore_mutations
});
;// CONCATENATED MODULE: external "vue"
var external_vue_namespaceObject = require("vue");
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ApiView.vue?vue&type=template&id=536e9364

var _hoisted_1 = {
  class: "api-view"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_LoaderAtom = (0,external_vue_namespaceObject.resolveComponent)("LoaderAtom");
  var _component_DialogAtom = (0,external_vue_namespaceObject.resolveComponent)("DialogAtom");
  return (0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createElementBlock)("div", _hoisted_1, [$options.loader.isActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_LoaderAtom, {
    key: 0,
    mode: "fullscreen",
    header: $options.loader.message,
    nested: $options.loader.nested
  }, null, 8, ["header", "nested"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true), $options.error.isActive ? ((0,external_vue_namespaceObject.openBlock)(), (0,external_vue_namespaceObject.createBlock)(_component_DialogAtom, {
    key: 1,
    type: "error",
    onClose: $options.onErrorConfirm
  }, {
    default: (0,external_vue_namespaceObject.withCtx)(function () {
      return [(0,external_vue_namespaceObject.createTextVNode)((0,external_vue_namespaceObject.toDisplayString)($options.error.message), 1)];
    }),
    _: 1
  }, 8, ["onClose"])) : (0,external_vue_namespaceObject.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/ApiView.vue?vue&type=template&id=536e9364

;// CONCATENATED MODULE: external "@sgf/go-ace-ui"
var go_ace_ui_namespaceObject = require("@sgf/go-ace-ui");
;// CONCATENATED MODULE: external "vuex"
var external_vuex_namespaceObject = require("vuex");
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ApiView.vue?vue&type=script&lang=js








/* harmony default export */ var ApiViewvue_type_script_lang_js = ({
  components: {
    LoaderAtom: go_ace_ui_namespaceObject.LoaderAtom,
    DialogAtom: go_ace_ui_namespaceObject.DialogAtom
  },
  props: {
    correlationIds: Array
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_vuex_namespaceObject.mapState)('api', ['loaders', 'errors'])), {}, {
    loader: function loader() {
      var _this = this;
      var loader = {};
      this.correlationIds.forEach(function (x) {
        if (_this.loaders[x] && _this.loaders[x].isActive) {
          loader = _this.loaders[x];
        }
      });
      return loader;
    },
    error: function error() {
      var error = {};
      var errors = Object.values(this.errors).filter(function (x) {
        return x.isActive;
      });
      if (errors && errors.length > 0) {
        return errors[0];
      }
      return error;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, (0,external_vuex_namespaceObject.mapActions)({
    onConfirmError: apiStore_types.actions.SET_ERROR
  })), {}, {
    onErrorConfirm: function onErrorConfirm() {
      this.onConfirmError({
        correlationId: this.error.correlationId,
        isActive: false
      });
    }
  })
});
;// CONCATENATED MODULE: ./src/components/ApiView.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(6262);
;// CONCATENATED MODULE: ./src/components/ApiView.vue




;
const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.A)(ApiViewvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var ApiView = (__exports__);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__(6412);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__(8125);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(4782);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(2010);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__(4731);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__(479);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(3362);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js





















function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(8706);
;// CONCATENATED MODULE: ./src/helpers/loader-helper.js

function setLoader(context, correlationId) {
  var isActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Laddar...';
  var origin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var nested = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  context.dispatch(apiStore_types.actions.SET_LOADER, {
    isActive: isActive,
    correlationId: correlationId,
    message: message,
    origin: origin,
    nested: nested
  }, {
    root: true
  });
}
function setError(context, correlationId) {
  var isActive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Laddar...';
  var origin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  context.dispatch(apiTypes.actions.SET_ERROR, {
    isActive: isActive,
    correlationId: correlationId,
    message: message,
    origin: origin
  }, {
    root: true
  });
}

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(8781);
;// CONCATENATED MODULE: ./src/services/serviceBase.js













var ServiceBase = /*#__PURE__*/function () {
  function ServiceBase() {
    _classCallCheck(this, ServiceBase);
    _defineProperty(this, "_abortControllers", {});
  }
  return _createClass(ServiceBase, [{
    key: "_getOptions",
    value: function _getOptions(context) {
      return context.rootGetters[apiStore_types.getters.OPTIONS];
    }
  }, {
    key: "_beginTracking",
    value: function _beginTracking() {
      window['ga'] = window['ga'] || function () {
        (window['ga'].q = window['ga'].q || []).push(arguments);
      };
      return new Date().getTime();
    }
  }, {
    key: "_postTiming",
    value: function _postTiming(api, method, requestStart) {
      var elapsedMilliseconds = new Date().getTime() - requestStart;
      window['ga'] = window['ga'] || function () {
        (window['ga'].q = window['ga'].q || []).push(arguments);
      };
      window['ga']('send', 'timing', api, method, elapsedMilliseconds);
    }
  }, {
    key: "_processResponse",
    value: function () {
      var _processResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, response, correlationId) {
        var loader, body, errorMessage;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (Object.prototype.hasOwnProperty.call(context.rootState.api.loaders, correlationId)) {
                loader = context.rootState.api.loaders[correlationId];
                if (loader.isActive) {
                  setLoader(context, correlationId, false);
                }
              }
              if (!response.ok) {
                _context.next = 7;
                break;
              }
              if (!(response.status === 200)) {
                _context.next = 6;
                break;
              }
              _context.next = 5;
              return response.json();
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return response.text();
            case 9:
              body = _context.sent;
              errorMessage = '';
              if (body) {
                errorMessage = JSON.parse(body);
              }
              return _context.abrupt("return", this._processError(context, correlationId, errorMessage, response.status));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _processResponse(_x5, _x6, _x7) {
        return _processResponse2.apply(this, arguments);
      }
      return _processResponse;
    }()
  }, {
    key: "_processError",
    value: function () {
      var _processError2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, correlationId, body, status) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setLoader(context, correlationId, false);
              if (correlationId) {
                context.dispatch(apiStore_types.actions.HANDLE_ERROR, {
                  code: status,
                  message: body,
                  correlationId: correlationId,
                  origin: this._origin
                }, {
                  root: true
                });
              }
              return _context2.abrupt("return", Promise.reject({
                code: status,
                message: body
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _processError(_x8, _x9, _x10, _x11) {
        return _processError2.apply(this, arguments);
      }
      return _processError;
    }() //endpoint: endpoint as a string, without base, eg. /test/endpoint
    //callOptions: fetch options, object, eg. { method: 'POST', body: JSON.stringify(payload) }
    //context: vuex context reference
    //correlationId: correlationId to be used to get loaders and errors
    //loaderMessage: string message to be used in loader, optional
    //abortable: boolean, if true, abortController will be used
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2, _x3, _x4) {
        return _fetch.apply(this, arguments);
      }
      fetch.toString = function () {
        return _fetch.toString();
      };
      return fetch;
    }(
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(endpoint, callOptions, context, correlationId) {
        var loaderMessage,
          abortable,
          nested,
          options,
          requestStart,
          signal,
          response,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loaderMessage = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : 'Vi håller på...';
              abortable = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : false;
              nested = _args3.length > 6 && _args3[6] !== undefined ? _args3[6] : false;
              options = this._getOptions(context);
              requestStart = this._beginTracking();
              if (abortable && this._abortControllers[correlationId]) {
                this._abortControllers[correlationId].abort();
              }
              if (abortable) {
                this._abortControllers[correlationId] = new AbortController();
              }
              _context3.prev = 7;
              setLoader(context, correlationId, true, loaderMessage, '', nested);
              signal = undefined;
              if (abortable) {
                signal = this._abortControllers[correlationId].signal;
              }
              _context3.next = 13;
              return fetch(options.baseUrl + endpoint, _objectSpread2(_objectSpread2(_objectSpread2({}, callOptions), options), {}, {
                signal: signal
              }));
            case 13:
              response = _context3.sent;
              this._postTiming(this._origin, correlationId, requestStart);
              if (abortable) {
                this._abortControllers[correlationId] = undefined;
              }
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](7);
              this._postTiming(this._origin, correlationId, requestStart);
              if (!(_context3.t0.message === 'The user aborted a request.')) {
                _context3.next = 24;
                break;
              }
              return _context3.abrupt("return");
            case 24:
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[7, 19]]);
      }));
      return function (_x12, _x13, _x14, _x15) {
        return _ref.apply(this, arguments);
      };
    }())
  }]);
}();
/* harmony default export */ var serviceBase = (ServiceBase);
;// CONCATENATED MODULE: ./src/services/clubsApi.js













var ClubApi = /*#__PURE__*/function (_ServiceBase) {
  function ClubApi() {
    var _this;
    _classCallCheck(this, ClubApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ClubApi, [].concat(args));
    _defineProperty(_this, "_origin", "clubsApi");
    return _this;
  }
  _inherits(ClubApi, _ServiceBase);
  return _createClass(ClubApi, [{
    key: "_getCoursesUrl",
    value: function _getCoursesUrl(baseUrl, clubId) {
      return "".concat(baseUrl, "/clubs/").concat(clubId, "/courses");
    }
  }, {
    key: "_getClubsUrl",
    value: function _getClubsUrl(baseUrl) {
      var searchPhrase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var searchPhraseQuery = "";
      if (searchPhrase) {
        searchPhraseQuery = "?searchPhrase=".concat(searchPhrase);
      }
      return "".concat(baseUrl, "/clubs").concat(searchPhraseQuery);
    }
  }, {
    key: "_getAccessibleClubsAndCoursesUrl",
    value: function _getAccessibleClubsAndCoursesUrl(baseUrl) {
      return "".concat(baseUrl, "/clubs/courses");
    }
  }, {
    key: "getCourses",
    value: function () {
      var _getCourses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, clubId) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = clubId;
              options = this._getOptions(context);
              endpoint = this._getCoursesUrl(options.baseUrl, clubId);
              setLoader(context, correlationId, true, "Laddar banor...", this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "GET"
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getCourses(_x, _x2) {
        return _getCourses.apply(this, arguments);
      }
      return getCourses;
    }()
  }, {
    key: "getClubs",
    value: function () {
      var _getClubs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, searchPhrase) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = "getClubs";
              options = this._getOptions(context);
              endpoint = this._getClubsUrl(options.baseUrl, searchPhrase);
              setLoader(context, correlationId, true, null, this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "GET"
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function getClubs(_x3, _x4) {
        return _getClubs.apply(this, arguments);
      }
      return getClubs;
    }()
  }, {
    key: "getAccessibleClubsAndCourses",
    value: function () {
      var _getAccessibleClubsAndCourses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // payload : { correlationId: string? }
              correlationId = payload.correlationId ? payload.correlationId : "getClubsAndCourses";
              options = this._getOptions(context);
              endpoint = this._getAccessibleClubsAndCoursesUrl(options.baseUrl);
              setLoader(context, correlationId, true, "Laddar klubbar och banor...", this._origin);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "GET"
              }));
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function getAccessibleClubsAndCourses(_x5, _x6) {
        return _getAccessibleClubsAndCourses.apply(this, arguments);
      }
      return getAccessibleClubsAndCourses;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var clubsApi = (ClubApi);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__(9391);
;// CONCATENATED MODULE: ./src/helpers/lilum-helper.js
/* global lilum_startTransaction, lilum_stopTransaction */

/* harmony default export */ var lilum_helper = ({
  start: function start(key) {
    if (window.lilum_startTransaction !== undefined) {
      try {
        lilum_startTransaction(key);
      } catch (e) {
        console.log(e);
      }
    }
  },
  end: function end(key) {
    if (window.lilum_stopTransaction !== undefined) {
      try {
        lilum_stopTransaction(key);
      } catch (e) {
        console.log(e);
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/services/scheduleApi.js
















var ScheduleApi = /*#__PURE__*/function (_ServiceBase) {
  function ScheduleApi() {
    var _this;
    _classCallCheck(this, ScheduleApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScheduleApi, [].concat(args));
    _defineProperty(_this, "_origin", 'scheduleApi');
    return _this;
  }
  _inherits(ScheduleApi, _ServiceBase);
  return _createClass(ScheduleApi, [{
    key: "_getScheduleUrl",
    value: function _getScheduleUrl(baseUrl, courseId) {
      var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var dateQuery = '';
      if (date) {
        dateQuery = "?date=".concat(date);
      }
      return "".concat(baseUrl, "/Schedules/").concat(courseId).concat(dateQuery);
    }
  }, {
    key: "_getSchedulePatchUrl",
    value: function _getSchedulePatchUrl(baseUrl, courseId, teeTimeId) {
      return "".concat(baseUrl, "/Schedules/").concat(courseId, "/Patch/").concat(teeTimeId);
    }
  }, {
    key: "_fetchWithTimeout",
    value: function () {
      var _fetchWithTimeout2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(endpoint, options, timeout) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new Promise(function (resolve, reject) {
                var timer = setTimeout(timeout);
                fetch(endpoint, options).then(function (response) {
                  resolve(response), function (err) {
                    return reject(err);
                  };
                }).finally(function () {
                  return clearTimeout(timer);
                }).catch(function () {
                  new Error('Failed to fetch');
                });
              });
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function _fetchWithTimeout(_x, _x2, _x3) {
        return _fetchWithTimeout2.apply(this, arguments);
      }
      return _fetchWithTimeout;
    }()
  }, {
    key: "getSchedule",
    value: function () {
      var _getSchedule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var silent,
          correlationId,
          options,
          endpoint,
          lilumPrefix,
          response,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              silent = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getScheduleUrl(options.baseUrl, payload.courseId, payload.date);
              if (!silent) {
                setLoader(context, correlationId, true, 'Laddar schema...', this._origin);
              }
              lilumPrefix = 'SCHEDULE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context2.next = 9;
              return this._fetchWithTimeout(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }), 4000);
            case 9:
              response = _context2.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getSchedule(_x4, _x5) {
        return _getSchedule.apply(this, arguments);
      }
      return getSchedule;
    }()
  }, {
    key: "getSchedulePatch",
    value: function () {
      var _getSchedulePatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var silent,
          correlationId,
          options,
          endpoint,
          lilumPrefix,
          response,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              silent = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getSchedulePatchUrl(options.baseUrl, payload.courseId, payload.teeTimeId);
              if (!silent) {
                setLoader(context, correlationId, true, 'Laddar starttid...', this._origin);
              }
              _context3.prev = 5;
              lilumPrefix = 'PATCH_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context3.next = 10;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 10:
              response = _context3.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](5);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[5, 15]]);
      }));
      function getSchedulePatch(_x6, _x7) {
        return _getSchedulePatch.apply(this, arguments);
      }
      return getSchedulePatch;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var scheduleApi = (ScheduleApi);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__(3110);
;// CONCATENATED MODULE: ./src/services/bookingApi.js















var BookingApi = /*#__PURE__*/function (_ServiceBase) {
  function BookingApi() {
    var _this;
    _classCallCheck(this, BookingApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BookingApi, [].concat(args));
    _defineProperty(_this, "_origin", 'bookingApi');
    return _this;
  }
  _inherits(BookingApi, _ServiceBase);
  return _createClass(BookingApi, [{
    key: "_getValidateBookingUrl",
    value: function _getValidateBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/Bookings/Validate");
    }
  }, {
    key: "_getCreateTeeTimeBookingUrl",
    value: function _getCreateTeeTimeBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/Bookings");
    }
  }, {
    key: "_getValidateRemoveBookingUrl",
    value: function _getValidateRemoveBookingUrl(baseUrl, bookingId) {
      return "".concat(baseUrl, "/Bookings/").concat(bookingId, "/Validate/Delete");
    }
  }, {
    key: "_getRemoveBookingUrl",
    value: function _getRemoveBookingUrl(baseUrl, payload) {
      var url = "".concat(baseUrl, "/Bookings/").concat(payload.bookingId);
      if (payload.removeItemBookings) url += "?removeItemBookings=".concat(payload.removeItemBookings);
      return url;
    }
  }, {
    key: "_getValidateMoveBookingUrl",
    value: function _getValidateMoveBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/Bookings/Move/Validate");
    }
  }, {
    key: "_getMoveBookingUrl",
    value: function _getMoveBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/Bookings/Move");
    }
  }, {
    key: "_getEditTeeTimeBookingUrl",
    value: function _getEditTeeTimeBookingUrl(baseUrl, bookingId) {
      return "".concat(baseUrl, "/Bookings/").concat(bookingId);
    }
  }, {
    key: "_getValidateEditedBookingUrl",
    value: function _getValidateEditedBookingUrl(baseUrl, bookingId) {
      return "".concat(baseUrl, "/Bookings/").concat(bookingId, "/Validate");
    }
  }, {
    key: "_getBookerUrl",
    value: function _getBookerUrl(baseUrl, bookingId) {
      return "".concat(baseUrl, "/Bookings/").concat(bookingId, "/Booker");
    }
  }, {
    key: "validateBooking",
    value: function () {
      var _validateBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getValidateBookingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context.prev = 4;
              lilumPrefix = 'BOOKINGS_VALIDATE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify({
                  teeTimeId: payload.teeTimeId,
                  bookerId: payload.bookerId,
                  players: payload.players,
                  teeTimeGroup: payload.teeTimeGroup
                })
              }));
            case 9:
              response = _context.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 14]]);
      }));
      function validateBooking(_x, _x2) {
        return _validateBooking.apply(this, arguments);
      }
      return validateBooking;
    }()
  }, {
    key: "createTeeTimeBooking",
    value: function () {
      var _createTeeTimeBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getCreateTeeTimeBookingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Sparar bokning...', this._origin);
              _context2.prev = 4;
              lilumPrefix = 'CREATE_TEETIME_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context2.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify({
                  teeTimeId: payload.teeTimeId,
                  bookerId: payload.bookerId,
                  players: payload.players,
                  teeTimeGroup: payload.teeTimeGroup
                })
              }));
            case 9:
              response = _context2.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 14]]);
      }));
      function createTeeTimeBooking(_x3, _x4) {
        return _createTeeTimeBooking.apply(this, arguments);
      }
      return createTeeTimeBooking;
    }()
  }, {
    key: "validateRemoveBooking",
    value: function () {
      var _validateRemoveBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'validateRemoveBooking';
              options = this._getOptions(context);
              endpoint = this._getValidateRemoveBookingUrl(options.baseUrl, payload.bookingId);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context3.prev = 4;
              lilumPrefix = 'BOOKINGS_VALIDATE_DELETE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context3.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST'
              }));
            case 9:
              response = _context3.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 14]]);
      }));
      function validateRemoveBooking(_x5, _x6) {
        return _validateRemoveBooking.apply(this, arguments);
      }
      return validateRemoveBooking;
    }()
  }, {
    key: "removeBooking",
    value: function () {
      var _removeBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'removeBooking';
              options = this._getOptions(context);
              endpoint = this._getRemoveBookingUrl(options.baseUrl, payload);
              setLoader(context, correlationId, true, 'Tar bort bokning...', this._origin);
              _context4.prev = 4;
              lilumPrefix = 'BOOKINGS_VALIDATE_DELETE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context4.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'DELETE'
              }));
            case 9:
              response = _context4.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context4.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](4);
              return _context4.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 14]]);
      }));
      function removeBooking(_x7, _x8) {
        return _removeBooking.apply(this, arguments);
      }
      return removeBooking;
    }()
  }, {
    key: "validateMoveBooking",
    value: function () {
      var _validateMoveBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              /* Payload
                {
                  courseId: "",
                  sourceTeeTimeId: "",
                  targetTeeTimeId: "",
                  seatIds: [""],
                  copy: false,
                  correlationId: ""
                }
              */
              correlationId = payload.correlationId ? payload.correlationId : 'validateMoveBooking';
              options = this._getOptions(context);
              endpoint = this._getValidateMoveBookingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context5.prev = 4;
              _context5.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context5.sent;
              return _context5.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](4);
              return _context5.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 11]]);
      }));
      function validateMoveBooking(_x9, _x10) {
        return _validateMoveBooking.apply(this, arguments);
      }
      return validateMoveBooking;
    }()
  }, {
    key: "moveBooking",
    value: function () {
      var _moveBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(context, payload) {
        var correlationId, options, endpoint, loaderMessage, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              /* Payload
                {
                  courseId: "",
                  sourceTeeTimeId: "",
                  targetTeeTimeId: "",
                  seatIds: [""],
                  copy: false,
                  corelationId: ""
                }
              */
              correlationId = payload.correlationId ? payload.correlationId : 'moveBooking';
              options = this._getOptions(context);
              endpoint = this._getMoveBookingUrl(options.baseUrl);
              loaderMessage = payload.copy ? 'Kopierar...' : 'Flyttar...';
              setLoader(context, correlationId, true, loaderMessage, this._origin);
              _context6.prev = 5;
              _context6.next = 8;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 8:
              response = _context6.sent;
              return _context6.abrupt("return", this._processResponse(context, response, correlationId));
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](5);
              return _context6.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[5, 12]]);
      }));
      function moveBooking(_x11, _x12) {
        return _moveBooking.apply(this, arguments);
      }
      return moveBooking;
    }()
  }, {
    key: "editTeeTimeBooking",
    value: function () {
      var _editTeeTimeBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getEditTeeTimeBookingUrl(options.baseUrl, payload.bookingId);
              setLoader(context, correlationId, true, 'Sparar bokning...', this._origin);
              _context7.prev = 4;
              lilumPrefix = 'BOOKINGS_EDIT_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context7.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'PUT',
                body: JSON.stringify({
                  bookerId: payload.bookerId,
                  players: payload.players
                })
              }));
            case 9:
              response = _context7.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context7.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](4);
              return _context7.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[4, 14]]);
      }));
      function editTeeTimeBooking(_x13, _x14) {
        return _editTeeTimeBooking.apply(this, arguments);
      }
      return editTeeTimeBooking;
    }()
  }, {
    key: "validateEditedTeeTimeBooking",
    value: function () {
      var _validateEditedTeeTimeBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getValidateEditedBookingUrl(options.baseUrl, payload.bookingId);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context8.prev = 4;
              lilumPrefix = 'BOOKINGS_EDIT_VALIDATE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context8.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify({
                  bookerId: payload.bookerId,
                  players: payload.players
                })
              }));
            case 9:
              response = _context8.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context8.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context8.prev = 14;
              _context8.t0 = _context8["catch"](4);
              return _context8.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[4, 14]]);
      }));
      function validateEditedTeeTimeBooking(_x15, _x16) {
        return _validateEditedTeeTimeBooking.apply(this, arguments);
      }
      return validateEditedTeeTimeBooking;
    }()
  }, {
    key: "getBooker",
    value: function () {
      var _getBooker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(context, bookingId) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              correlationId = 'getBooker';
              options = this._getOptions(context);
              endpoint = this._getBookerUrl(options.baseUrl, bookingId);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context9.prev = 4;
              _context9.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context9.sent;
              return _context9.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](4);
              return _context9.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[4, 11]]);
      }));
      function getBooker(_x17, _x18) {
        return _getBooker.apply(this, arguments);
      }
      return getBooker;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var bookingApi = (BookingApi);
;// CONCATENATED MODULE: ./src/services/holidaysApi.js













var HolidaysApi = /*#__PURE__*/function (_ServiceBase) {
  function HolidaysApi() {
    var _this;
    _classCallCheck(this, HolidaysApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HolidaysApi, [].concat(args));
    _defineProperty(_this, "_origin", "holidaysApi");
    return _this;
  }
  _inherits(HolidaysApi, _ServiceBase);
  return _createClass(HolidaysApi, [{
    key: "_getHolidaysUrl",
    value: function _getHolidaysUrl(baseUrl) {
      return "".concat(baseUrl, "/Holidays");
    }
  }, {
    key: "getHolidays",
    value: function () {
      var _getHolidays = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = "getHolidays";
              options = this._getOptions(context);
              endpoint = this._getHolidaysUrl(options.baseUrl);
              setLoader(context, correlationId, true, "Hämtar...", this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "GET"
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getHolidays(_x) {
        return _getHolidays.apply(this, arguments);
      }
      return getHolidays;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var holidaysApi = (HolidaysApi);
;// CONCATENATED MODULE: ./src/services/personsApi.js















var PersonsApi = /*#__PURE__*/function (_ServiceBase) {
  function PersonsApi() {
    var _this;
    _classCallCheck(this, PersonsApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PersonsApi, [].concat(args));
    _defineProperty(_this, "_origin", 'personsApi');
    return _this;
  }
  _inherits(PersonsApi, _ServiceBase);
  return _createClass(PersonsApi, [{
    key: "_getPersonByGolfIdUrl",
    value: function _getPersonByGolfIdUrl(baseUrl, payload) {
      var golfIdQuery = '';
      if (payload.golfId) golfIdQuery = "?golfId=".concat(payload.golfId);
      if (payload.isMarkerSearch) golfIdQuery += "&isMarkerSearch=true";
      return "".concat(baseUrl, "/persons").concat(golfIdQuery);
    }
  }, {
    key: "_getPersonByIdUrl",
    value: function _getPersonByIdUrl(baseUrl, personId) {
      return "".concat(baseUrl, "/persons/").concat(personId);
    }
  }, {
    key: "_getSearchPersonsUrl",
    value: function _getSearchPersonsUrl(baseUrl) {
      var phrase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var clubId = arguments.length > 2 ? arguments[2] : undefined;
      var country = arguments.length > 3 ? arguments[3] : undefined;
      var isMarkerSearch = arguments.length > 4 ? arguments[4] : undefined;
      var phraseQuery = '';
      if (phrase) phraseQuery = "?searchPhrase=".concat(phrase);
      if (clubId) phraseQuery += "&clubId=".concat(clubId);
      if (country) phraseQuery += "&country=".concat(country);
      if (isMarkerSearch) phraseQuery += "&isMarkerSearch=true";
      return "".concat(baseUrl, "/Persons").concat(phraseQuery);
    }
  }, {
    key: "_getPersonFullnameUrl",
    value: function _getPersonFullnameUrl(baseUrl, personId) {
      return "".concat(baseUrl, "/persons/").concat(personId, "/fullname");
    }
  }, {
    key: "_getCreatePersonUrl",
    value: function _getCreatePersonUrl(baseUrl) {
      return "".concat(baseUrl, "/persons");
    }
  }, {
    key: "getPersonByGolfId",
    value: function () {
      var _getPersonByGolfId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, lilumEndpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getPersonByGolfId';
              options = this._getOptions(context);
              endpoint = this._getPersonByGolfIdUrl(options.baseUrl, payload);
              lilumEndpoint = this._getPersonByGolfIdUrl(options.baseUrl, {});
              setLoader(context, correlationId, true, 'Söker...', this._origin);
              _context.prev = 5;
              lilumPrefix = 'PERSON_SEARCH_GOLFID_';
              lilum_helper.start(lilumPrefix + lilumEndpoint);
              _context.next = 10;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 10:
              response = _context.sent;
              lilum_helper.end(lilumPrefix + lilumEndpoint);
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 15]]);
      }));
      function getPersonByGolfId(_x, _x2) {
        return _getPersonByGolfId.apply(this, arguments);
      }
      return getPersonByGolfId;
    }()
  }, {
    key: "searchPerson",
    value: function () {
      var _searchPerson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, lilumEndpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'searchPerson';
              options = this._getOptions(context);
              endpoint = this._getSearchPersonsUrl(options.baseUrl, payload.phrase, payload.clubId, payload.country, payload.isMarkerSearch);
              lilumEndpoint = this._getSearchPersonsUrl(options.baseUrl, '', '', '', '');
              setLoader(context, correlationId, true, 'Söker...', this._origin);
              _context2.prev = 5;
              lilumPrefix = 'PERSON_SEARCH_PHRASE_';
              lilum_helper.start(lilumPrefix + lilumEndpoint);
              _context2.next = 10;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 10:
              response = _context2.sent;
              lilum_helper.end(lilumPrefix + lilumEndpoint);
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](5);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[5, 15]]);
      }));
      function searchPerson(_x3, _x4) {
        return _searchPerson.apply(this, arguments);
      }
      return searchPerson;
    }()
  }, {
    key: "getPersonById",
    value: function () {
      var _getPersonById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getPersonById';
              options = this._getOptions(context);
              endpoint = this._getPersonByIdUrl(options.baseUrl, payload.personId);
              setLoader(context, correlationId, true, 'Söker...', this._origin);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function getPersonById(_x5, _x6) {
        return _getPersonById.apply(this, arguments);
      }
      return getPersonById;
    }()
  }, {
    key: "getPersonFullname",
    value: function () {
      var _getPersonFullname = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getPersonFullname';
              options = this._getOptions(context);
              endpoint = this._getPersonFullnameUrl(options.baseUrl, payload.personId);
              setLoader(context, correlationId, true, 'Söker...', this._origin);
              _context4.prev = 4;
              _context4.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context4.sent;
              return _context4.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              return _context4.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 11]]);
      }));
      function getPersonFullname(_x7, _x8) {
        return _getPersonFullname.apply(this, arguments);
      }
      return getPersonFullname;
    }()
  }, {
    key: "createPerson",
    value: function () {
      var _createPerson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'createPerson';
              options = this._getOptions(context);
              endpoint = this._getCreatePersonUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context5.prev = 4;
              _context5.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context5.sent;
              return _context5.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](4);
              return _context5.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 11]]);
      }));
      function createPerson(_x9, _x10) {
        return _createPerson.apply(this, arguments);
      }
      return createPerson;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var personsApi = (PersonsApi);
;// CONCATENATED MODULE: ./src/services/countriesApi.js













var CountriesApi = /*#__PURE__*/function (_ServiceBase) {
  function CountriesApi() {
    var _this;
    _classCallCheck(this, CountriesApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CountriesApi, [].concat(args));
    _defineProperty(_this, "_origin", "countriesApi");
    return _this;
  }
  _inherits(CountriesApi, _ServiceBase);
  return _createClass(CountriesApi, [{
    key: "_getCountriesUrl",
    value: function _getCountriesUrl(baseUrl) {
      return "".concat(baseUrl, "/countries");
    }
  }, {
    key: "getCountries",
    value: function () {
      var _getCountries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = "getCountries";
              options = this._getOptions(context);
              endpoint = this._getCountriesUrl(options.baseUrl);
              setLoader(context, correlationId, true, "Hämtar...", this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "GET"
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getCountries(_x) {
        return _getCountries.apply(this, arguments);
      }
      return getCountries;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var countriesApi = (CountriesApi);
;// CONCATENATED MODULE: ./src/services/slotBookingApi.js














var SlotBookingApi = /*#__PURE__*/function (_ServiceBase) {
  function SlotBookingApi() {
    var _this;
    _classCallCheck(this, SlotBookingApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SlotBookingApi, [].concat(args));
    _defineProperty(_this, "_origin", 'slotBookingAPi');
    return _this;
  }
  _inherits(SlotBookingApi, _ServiceBase);
  return _createClass(SlotBookingApi, [{
    key: "_getArrivalUrl",
    value: function _getArrivalUrl(baseUrl, slotBookingId) {
      return "".concat(baseUrl, "/SlotBookings/").concat(slotBookingId, "/Arrival");
    }
  }, {
    key: "_getValidateRemovePlayerUrl",
    value: function _getValidateRemovePlayerUrl(baseUrl, slotBookingId) {
      return "".concat(baseUrl, "/SlotBookings/").concat(slotBookingId, "/Validate/Delete");
    }
  }, {
    key: "_getRemovePlayerUrl",
    value: function _getRemovePlayerUrl(baseUrl, payload) {
      var url = "".concat(baseUrl, "/SlotBookings/").concat(payload.slotBookingId);
      if (payload.removeItemBookings) url += "?removeItemBookings=".concat(payload.removeItemBookings);
      return url;
    }
  }, {
    key: "_getSlotBookingUrl",
    value: function _getSlotBookingUrl(baseUrl, slotBookingId) {
      return "".concat(baseUrl, "/SlotBookings/").concat(slotBookingId);
    }
  }, {
    key: "getSlotBookingFeeAndItemsUrl",
    value: function getSlotBookingFeeAndItemsUrl(baseUrl, slotBookingId) {
      return "".concat(baseUrl, "/SlotBookings/").concat(slotBookingId, "/FeeAndItems");
    }
  }, {
    key: "_getValidateSlotBookingUrl",
    value: function _getValidateSlotBookingUrl(baseUrl, slotBookingId) {
      return "".concat(baseUrl, "/SlotBookings/").concat(slotBookingId, "/Validate");
    }
  }, {
    key: "setArrival",
    value: function () {
      var _setArrival = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = 'updateArrival';
              options = this._getOptions(context);
              endpoint = this._getArrivalUrl(options.baseUrl, payload.seatId);
              setLoader(context, correlationId, true, 'Ankomstmarkerar...', this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify({
                  playerId: payload.playerId,
                  hasArrived: payload.hasArrived,
                  courseId: payload.courseId
                })
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function setArrival(_x, _x2) {
        return _setArrival.apply(this, arguments);
      }
      return setArrival;
    }()
  }, {
    key: "validateRemovePlayer",
    value: function () {
      var _validateRemovePlayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'validateRemovePlayer';
              options = this._getOptions(context);
              endpoint = this._getValidateRemovePlayerUrl(options.baseUrl, payload.slotBookingId);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST'
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function validateRemovePlayer(_x3, _x4) {
        return _validateRemovePlayer.apply(this, arguments);
      }
      return validateRemovePlayer;
    }()
  }, {
    key: "getSlotBooking",
    value: function () {
      var _getSlotBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getSlotBookingUrl(options.baseUrl, payload.slotBookingId);
              setLoader(context, correlationId, true, 'Hämtar...', this._origin);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function getSlotBooking(_x5, _x6) {
        return _getSlotBooking.apply(this, arguments);
      }
      return getSlotBooking;
    }()
  }, {
    key: "editSlotBooking",
    value: function () {
      var _editSlotBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getSlotBookingUrl(options.baseUrl, payload.slotBookingId);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context4.prev = 4;
              _context4.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'PUT',
                body: JSON.stringify({
                  id: payload.slotBookingId,
                  note: payload.slotBooking.note,
                  player: payload.slotBooking.player
                })
              }));
            case 7:
              response = _context4.sent;
              return _context4.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              return _context4.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 11]]);
      }));
      function editSlotBooking(_x7, _x8) {
        return _editSlotBooking.apply(this, arguments);
      }
      return editSlotBooking;
    }()
  }, {
    key: "validateSlotBooking",
    value: function () {
      var _validateSlotBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getValidateSlotBookingUrl(options.baseUrl, payload.slotBookingId);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context5.prev = 4;
              _context5.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'PUT',
                body: JSON.stringify({
                  id: payload.slotBookingId,
                  note: payload.slotBooking.note,
                  player: payload.slotBooking.player
                })
              }));
            case 7:
              response = _context5.sent;
              return _context5.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](4);
              return _context5.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 11]]);
      }));
      function validateSlotBooking(_x9, _x10) {
        return _validateSlotBooking.apply(this, arguments);
      }
      return validateSlotBooking;
    }()
  }, {
    key: "removePlayer",
    value: function () {
      var _removePlayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'removePlayer';
              options = this._getOptions(context);
              endpoint = this._getRemovePlayerUrl(options.baseUrl, payload);
              setLoader(context, correlationId, true, 'Tar bort spelare...', this._origin);
              _context6.prev = 4;
              _context6.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'DELETE'
              }));
            case 7:
              response = _context6.sent;
              return _context6.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](4);
              return _context6.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[4, 11]]);
      }));
      function removePlayer(_x11, _x12) {
        return _removePlayer.apply(this, arguments);
      }
      return removePlayer;
    }()
  }, {
    key: "editFeeAndItems",
    value: function () {
      var _editFeeAndItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this.getSlotBookingFeeAndItemsUrl(options.baseUrl, payload.slotBookingId);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context7.prev = 4;
              _context7.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context7.sent;
              return _context7.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](4);
              return _context7.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[4, 11]]);
      }));
      function editFeeAndItems(_x13, _x14) {
        return _editFeeAndItems.apply(this, arguments);
      }
      return editFeeAndItems;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var slotBookingApi = (SlotBookingApi);
;// CONCATENATED MODULE: ./src/services/userApi.js














var UserApi = /*#__PURE__*/function (_ServiceBase) {
  function UserApi() {
    var _this;
    _classCallCheck(this, UserApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserApi, [].concat(args));
    _defineProperty(_this, "_origin", 'userApi');
    return _this;
  }
  _inherits(UserApi, _ServiceBase);
  return _createClass(UserApi, [{
    key: "_getUserScheduleSettingsUrl",
    value: function _getUserScheduleSettingsUrl(baseUrl) {
      return "".concat(baseUrl, "/Users/Settings");
    }
  }, {
    key: "getUserScheduleSettings",
    value: function () {
      var _getUserScheduleSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload;
              options = this._getOptions(context);
              endpoint = this._getUserScheduleSettingsUrl(options.baseUrl, payload);
              setLoader(context, correlationId, true, 'Laddar banor...', this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getUserScheduleSettings(_x, _x2) {
        return _getUserScheduleSettings.apply(this, arguments);
      }
      return getUserScheduleSettings;
    }()
  }, {
    key: "putUserSettings",
    value: function () {
      var _putUserSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.fetch("/users/settings", {
                method: 'PUT',
                body: JSON.stringify(payload)
              }, context, 'putUserSettings', 'Sparar...');
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function putUserSettings(_x3, _x4) {
        return _putUserSettings.apply(this, arguments);
      }
      return putUserSettings;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var userApi = (UserApi);
;// CONCATENATED MODULE: ./src/services/teeTimeApi.js















var TeeTimeApi = /*#__PURE__*/function (_ServiceBase) {
  function TeeTimeApi() {
    var _this;
    _classCallCheck(this, TeeTimeApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TeeTimeApi, [].concat(args));
    _defineProperty(_this, "_origin", 'teeTimeApi');
    return _this;
  }
  _inherits(TeeTimeApi, _ServiceBase);
  return _createClass(TeeTimeApi, [{
    key: "_getCreateTeeTimeLockUrl",
    value: function _getCreateTeeTimeLockUrl(baseUrl, teeTimeId) {
      return "".concat(baseUrl, "/TeeTimes/").concat(teeTimeId, "/Lock");
    }
  }, {
    key: "_getDeleteTeeTimeLockUrl",
    value: function _getDeleteTeeTimeLockUrl(baseUrl, teeTimeId) {
      return "".concat(baseUrl, "/TeeTimes/").concat(teeTimeId, "/Unlock");
    }
  }, {
    key: "_getdeleteAllOwnLocksUrl",
    value: function _getdeleteAllOwnLocksUrl(baseUrl) {
      return "".concat(baseUrl, "/TeeTimes/Unlock");
    }
  }, {
    key: "_getArrivalForAllUrl",
    value: function _getArrivalForAllUrl(baseUrl, teeTimeId) {
      return "".concat(baseUrl, "/TeeTimes/").concat(teeTimeId, "/Arrival");
    }
  }, {
    key: "createTeeTimeLock",
    value: function () {
      var _createTeeTimeLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getCreateTeeTimeLockUrl(options.baseUrl, payload.teeTimeId);
              setLoader(context, correlationId, true, 'Låser...', this._origin);
              _context.prev = 4;
              lilumPrefix = 'TEETIME_LOCK_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 9:
              response = _context.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 14]]);
      }));
      function createTeeTimeLock(_x, _x2) {
        return _createTeeTimeLock.apply(this, arguments);
      }
      return createTeeTimeLock;
    }()
  }, {
    key: "deleteTeeTimeLock",
    value: function () {
      var _deleteTeeTimeLock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // payload: { courseId: String, teeTimeId: String, correlationId: String? }
              correlationId = payload.correlationId ? payload.correlationId : payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getDeleteTeeTimeLockUrl(options.baseUrl, payload.teeTimeId);
              setLoader(context, correlationId, true, 'Låser upp...', this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function deleteTeeTimeLock(_x3, _x4) {
        return _deleteTeeTimeLock.apply(this, arguments);
      }
      return deleteTeeTimeLock;
    }()
  }, {
    key: "deleteAllOwnLocks",
    value: function () {
      var _deleteAllOwnLocks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = 'deleteAllOwnLocks';
              options = this._getOptions(context);
              endpoint = this._getdeleteAllOwnLocksUrl(options.baseUrl);
              setLoader(context, correlationId, true, null, this._origin);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function deleteAllOwnLocks(_x5) {
        return _deleteAllOwnLocks.apply(this, arguments);
      }
      return deleteAllOwnLocks;
    }()
  }, {
    key: "setArrivalForAll",
    value: function () {
      var _setArrivalForAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              correlationId = 'updateArrivalAll';
              options = this._getOptions(context);
              endpoint = this._getArrivalForAllUrl(options.baseUrl, payload.teeTimeId);
              setLoader(context, correlationId, true, 'Ankomstmarkerar...', this._origin);
              _context4.prev = 4;
              _context4.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify({
                  hasArrived: payload.hasArrived
                })
              }));
            case 7:
              response = _context4.sent;
              return _context4.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              return _context4.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 11]]);
      }));
      function setArrivalForAll(_x6, _x7) {
        return _setArrivalForAll.apply(this, arguments);
      }
      return setArrivalForAll;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var teeTimeApi = (TeeTimeApi);
;// CONCATENATED MODULE: ./src/services/scoreCardApi.js















var ScoreCardApi = /*#__PURE__*/function (_ServiceBase) {
  function ScoreCardApi() {
    var _this;
    _classCallCheck(this, ScoreCardApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScoreCardApi, [].concat(args));
    _defineProperty(_this, "_origin", 'scoreCardApi');
    return _this;
  }
  _inherits(ScoreCardApi, _ServiceBase);
  return _createClass(ScoreCardApi, [{
    key: "_getScoreCardUrl",
    value: function _getScoreCardUrl(baseUrl) {
      return "".concat(baseUrl, "/scorecard");
    }
  }, {
    key: "_getScoreCardParams",
    value: function _getScoreCardParams(payload) {
      var params = "?courseId=".concat(payload.courseId);
      payload.golfIds.forEach(function (golfId) {
        params += "&golfIds=".concat(golfId);
      });
      return params;
    }
  }, {
    key: "_getPrintScoreCardUrl",
    value: function _getPrintScoreCardUrl(baseUrl) {
      return "".concat(baseUrl, "/scorecard/print");
    }
  }, {
    key: "getScoreCardSettings",
    value: function () {
      var _getScoreCardSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getScoreCard';
              options = this._getOptions(context);
              endpoint = this._getScoreCardUrl(options.baseUrl) + this._getScoreCardParams(payload);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getScoreCardSettings(_x, _x2) {
        return _getScoreCardSettings.apply(this, arguments);
      }
      return getScoreCardSettings;
    }()
  }, {
    key: "printScoreCard",
    value: function () {
      var _printScoreCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = 'printScoreCard';
              options = this._getOptions(context);
              endpoint = this._getPrintScoreCardUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Skriver ut scorekort...', this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function printScoreCard(_x3, _x4) {
        return _printScoreCard.apply(this, arguments);
      }
      return printScoreCard;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var scoreCardApi = (ScoreCardApi);
;// CONCATENATED MODULE: ./src/services/teeApi.js













var TeeApi = /*#__PURE__*/function (_ServiceBase) {
  function TeeApi() {
    var _this;
    _classCallCheck(this, TeeApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TeeApi, [].concat(args));
    _defineProperty(_this, "_origin", "teeApi");
    return _this;
  }
  _inherits(TeeApi, _ServiceBase);
  return _createClass(TeeApi, [{
    key: "_getTeesUrl",
    value: function _getTeesUrl(baseUrl, payload) {
      return "".concat(baseUrl, "/tees?courseId=").concat(payload.courseId, "&date=").concat(payload.date);
    }
  }, {
    key: "getTees",
    value: function () {
      var _getTees = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = "getTees";
              options = this._getOptions(context);
              endpoint = this._getTeesUrl(options.baseUrl, payload);
              setLoader(context, correlationId, true, "Laddar...", this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "GET"
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getTees(_x, _x2) {
        return _getTees.apply(this, arguments);
      }
      return getTees;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var teeApi = (TeeApi);
;// CONCATENATED MODULE: ./src/services/blockingApi.js
















var BlockingApi = /*#__PURE__*/function (_ServiceBase) {
  function BlockingApi() {
    var _this;
    _classCallCheck(this, BlockingApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BlockingApi, [].concat(args));
    _defineProperty(_this, "_origin", 'blockingApi');
    return _this;
  }
  _inherits(BlockingApi, _ServiceBase);
  return _createClass(BlockingApi, [{
    key: "_getBlockingUrl",
    value: function _getBlockingUrl(baseUrl) {
      return "".concat(baseUrl, "/Blockings");
    }
  }, {
    key: "_getUpdateBlockingUrl",
    value: function _getUpdateBlockingUrl(baseUrl, blockingId) {
      return "".concat(baseUrl, "/Blockings/").concat(blockingId);
    }
  }, {
    key: "_getDeleteBlockingUrl",
    value: function _getDeleteBlockingUrl(baseUrl) {
      return "".concat(baseUrl, "/Blockings");
    }
  }, {
    key: "_getDeleteBlockingParams",
    value: function _getDeleteBlockingParams(payload) {
      var params = "?";
      payload.forEach(function (id) {
        params += "blockingIds=".concat(id, "&");
      });
      params = params.slice(0, -1);
      return params;
    }
  }, {
    key: "createBlocking",
    value: function () {
      var _createBlocking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //payload: [{ teeTimeId, note, blockedSlots }]
              correlationId = payload.correlationId ? payload.correlationId : 'createBlocking';
              options = this._getOptions(context);
              endpoint = this._getBlockingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Sparar blockering...', this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload.blockings)
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function createBlocking(_x, _x2) {
        return _createBlocking.apply(this, arguments);
      }
      return createBlocking;
    }()
  }, {
    key: "editBlocking",
    value: function () {
      var _editBlocking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              //payload: [{ id, teeTimeId, note, blockedSlots }]
              correlationId = payload.correlationId ? payload.correlationId : 'createBlocking';
              options = this._getOptions(context);
              endpoint = this._getUpdateBlockingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Sparar blockering...', this._origin);
              //TODO: fix unnecessary mapping in body, understand why array is sent
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'PUT',
                body: JSON.stringify(payload.blockings)
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function editBlocking(_x3, _x4) {
        return _editBlocking.apply(this, arguments);
      }
      return editBlocking;
    }()
  }, {
    key: "deleteBlocking",
    value: function () {
      var _deleteBlocking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              //payload: [ blockingIds ]
              correlationId = payload.correlationId ? payload.correlationId : 'deleteBlocking';
              options = this._getOptions(context);
              endpoint = this._getDeleteBlockingUrl(options.baseUrl, payload) + this._getDeleteBlockingParams(payload);
              setLoader(context, correlationId, true, 'Tar bort blockering...', this._origin);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'DELETE'
              }));
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function deleteBlocking(_x5, _x6) {
        return _deleteBlocking.apply(this, arguments);
      }
      return deleteBlocking;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var blockingApi = (BlockingApi);
;// CONCATENATED MODULE: ./src/services/hcpApi.js















var HcpApi = /*#__PURE__*/function (_ServiceBase) {
  function HcpApi() {
    var _this;
    _classCallCheck(this, HcpApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HcpApi, [].concat(args));
    _defineProperty(_this, "_origin", 'hcpApi');
    return _this;
  }
  _inherits(HcpApi, _ServiceBase);
  return _createClass(HcpApi, [{
    key: "_getScoresUrl",
    value: function _getScoresUrl(baseUrl, personId, offset) {
      return "".concat(baseUrl, "/hcp/scores/persons/").concat(personId, "?offset=").concat(offset);
    }
  }, {
    key: "_getPersonUrl",
    value: function _getPersonUrl(baseUrl, personId) {
      return "".concat(baseUrl, "/hcp/persons/").concat(personId);
    }
  }, {
    key: "_getCourseUrl",
    value: function _getCourseUrl(baseUrl, courseId, date) {
      return "".concat(baseUrl, "/hcp/courses/").concat(courseId, "?date=").concat(date);
    }
  }, {
    key: "_getCreateAdjustmentUrl",
    value: function _getCreateAdjustmentUrl(baseUrl) {
      return "".concat(baseUrl, "/hcp/adjustments");
    }
  }, {
    key: "_getRemoveAdjustmentUrl",
    value: function _getRemoveAdjustmentUrl(baseUrl, adjustmentId) {
      return "".concat(baseUrl, "/hcp/adjustments/").concat(adjustmentId);
    }
  }, {
    key: "_getAdjustmentsUrl",
    value: function _getAdjustmentsUrl(baseUrl, personId) {
      return "".concat(baseUrl, "/hcp/adjustments/persons/").concat(personId);
    }
  }, {
    key: "_getRoundsUrl",
    value: function _getRoundsUrl(baseUrl, payload) {
      return "".concat(baseUrl, "/hcp/rounds/persons/").concat(payload.personId, "?offset=").concat(payload.offset);
    }
  }, {
    key: "_postScoreUrl",
    value: function _postScoreUrl(baseUrl) {
      return "".concat(baseUrl, "/hcp/scores");
    }
  }, {
    key: "_removeScoreUrl",
    value: function _removeScoreUrl(baseUrl, scoreId) {
      return "".concat(baseUrl, "/hcp/scores/").concat(scoreId);
    }
  }, {
    key: "_getHcpCertificateUrl",
    value: function _getHcpCertificateUrl(baseUrl, personId) {
      return "".concat(baseUrl, "/hcp/certificate/").concat(personId);
    }
  }, {
    key: "_getScoreAdjustmentsUrl",
    value: function _getScoreAdjustmentsUrl(baseUrl, scoreId) {
      return "".concat(baseUrl, "/hcp/scores/").concat(scoreId, "/adjustments");
    }
  }, {
    key: "getScores",
    value: function () {
      var _getScores = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.correlationId;
              options = this._getOptions(context);
              endpoint = this._getScoresUrl(options.baseUrl, payload.personId, payload.offset);
              setLoader(context, correlationId, true, 'Laddar ronder...', this._origin);
              _context.prev = 4;
              lilumPrefix = 'GET_SCORES_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 9:
              response = _context.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 14]]);
      }));
      function getScores(_x, _x2) {
        return _getScores.apply(this, arguments);
      }
      return getScores;
    }()
  }, {
    key: "getPerson",
    value: function () {
      var _getPerson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId;
              options = this._getOptions(context);
              endpoint = this._getPersonUrl(options.baseUrl, payload.personId);
              setLoader(context, correlationId, true, 'Laddar person...', this._origin);
              _context2.prev = 4;
              lilumPrefix = 'GET_PERSON_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context2.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 9:
              response = _context2.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 14]]);
      }));
      function getPerson(_x3, _x4) {
        return _getPerson.apply(this, arguments);
      }
      return getPerson;
    }()
  }, {
    key: "getCourse",
    value: function () {
      var _getCourse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = payload.correlationId;
              options = this._getOptions(context);
              endpoint = this._getCourseUrl(options.baseUrl, payload.courseId, payload.date);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context3.prev = 4;
              lilumPrefix = 'GET_COURSE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context3.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 9:
              response = _context3.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 14]]);
      }));
      function getCourse(_x5, _x6) {
        return _getCourse.apply(this, arguments);
      }
      return getCourse;
    }()
  }, {
    key: "createAdjustment",
    value: function () {
      var _createAdjustment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              correlationId = payload.correlationId;
              options = this._getOptions(context);
              endpoint = this._getCreateAdjustmentUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context4.prev = 4;
              lilumPrefix = 'CREATE_ADJUSTMENT_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context4.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify({
                  personId: payload.personId,
                  hcp: payload.hcp,
                  note: payload.note
                })
              }));
            case 9:
              response = _context4.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context4.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](4);
              return _context4.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 14]]);
      }));
      function createAdjustment(_x7, _x8) {
        return _createAdjustment.apply(this, arguments);
      }
      return createAdjustment;
    }()
  }, {
    key: "removeAdjustment",
    value: function () {
      var _removeAdjustment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'removeAdjustment';
              options = this._getOptions(context);
              endpoint = this._getRemoveAdjustmentUrl(options.baseUrl, payload.adjustmentId);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context5.prev = 4;
              lilumPrefix = 'REMOVE_ADJUSTMENT_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context5.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'DELETE'
              }));
            case 9:
              response = _context5.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context5.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context5.prev = 14;
              _context5.t0 = _context5["catch"](4);
              return _context5.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 14]]);
      }));
      function removeAdjustment(_x9, _x10) {
        return _removeAdjustment.apply(this, arguments);
      }
      return removeAdjustment;
    }()
  }, {
    key: "getAdjustments",
    value: function () {
      var _getAdjustments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getAdjustments';
              options = this._getOptions(context);
              endpoint = this._getAdjustmentsUrl(options.baseUrl, payload);
              setLoader(context, correlationId, true, 'Hämtar...', this._origin);
              _context6.prev = 4;
              lilumPrefix = 'GET_ADJUSTMENT_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context6.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 9:
              response = _context6.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context6.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context6.prev = 14;
              _context6.t0 = _context6["catch"](4);
              return _context6.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[4, 14]]);
      }));
      function getAdjustments(_x11, _x12) {
        return _getAdjustments.apply(this, arguments);
      }
      return getAdjustments;
    }()
  }, {
    key: "getScoreAdjustments",
    value: function () {
      var _getScoreAdjustments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getScoreAdjustments';
              options = this._getOptions(context);
              endpoint = this._getScoreAdjustmentsUrl(options.baseUrl, payload.scoreId);
              setLoader(context, correlationId, true, 'Hämtar...', this._origin);
              _context7.prev = 4;
              lilumPrefix = 'GET_SCORE_ADJUSTMENT_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context7.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 9:
              response = _context7.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context7.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](4);
              return _context7.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[4, 14]]);
      }));
      function getScoreAdjustments(_x13, _x14) {
        return _getScoreAdjustments.apply(this, arguments);
      }
      return getScoreAdjustments;
    }()
  }, {
    key: "getRounds",
    value: function () {
      var _getRounds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              correlationId = payload.correlationId;
              options = this._getOptions(context);
              endpoint = this._getRoundsUrl(options.baseUrl, payload);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context8.prev = 4;
              lilumPrefix = 'GET_SCORES_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context8.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 9:
              response = _context8.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context8.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context8.prev = 14;
              _context8.t0 = _context8["catch"](4);
              return _context8.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[4, 14]]);
      }));
      function getRounds(_x15, _x16) {
        return _getRounds.apply(this, arguments);
      }
      return getRounds;
    }()
  }, {
    key: "postScore",
    value: function () {
      var _postScore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              correlationId = payload.correlationId;
              options = this._getOptions(context);
              endpoint = this._postScoreUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context9.prev = 4;
              lilumPrefix = 'POST_SCORE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context9.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 9:
              response = _context9.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context9.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context9.prev = 14;
              _context9.t0 = _context9["catch"](4);
              return _context9.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[4, 14]]);
      }));
      function postScore(_x17, _x18) {
        return _postScore.apply(this, arguments);
      }
      return postScore;
    }()
  }, {
    key: "removeScore",
    value: function () {
      var _removeScore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(context, payload) {
        var correlationId, options, endpoint, lilumPrefix, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              correlationId = payload.correlationId;
              options = this._getOptions(context);
              endpoint = this._removeScoreUrl(options.baseUrl, payload.scoreId);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context10.prev = 4;
              lilumPrefix = 'DELETE_SCORE_';
              lilum_helper.start(lilumPrefix + endpoint);
              _context10.next = 9;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'DELETE'
              }));
            case 9:
              response = _context10.sent;
              lilum_helper.end(lilumPrefix + endpoint);
              return _context10.abrupt("return", this._processResponse(context, response, correlationId));
            case 14:
              _context10.prev = 14;
              _context10.t0 = _context10["catch"](4);
              return _context10.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 17:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[4, 14]]);
      }));
      function removeScore(_x19, _x20) {
        return _removeScore.apply(this, arguments);
      }
      return removeScore;
    }()
  }, {
    key: "getHcpCertificate",
    value: function () {
      var _getHcpCertificate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getHcpCertificate';
              options = this._getOptions(context);
              endpoint = this._getHcpCertificateUrl(options.baseUrl, payload.personId);
              setLoader(context, correlationId, true, 'Laddar hcp-bevis...', this._origin);
              _context11.prev = 4;
              _context11.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context11.sent;
              return _context11.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context11.prev = 11;
              _context11.t0 = _context11["catch"](4);
              return _context11.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[4, 11]]);
      }));
      function getHcpCertificate(_x21, _x22) {
        return _getHcpCertificate.apply(this, arguments);
      }
      return getHcpCertificate;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var hcpApi = (HcpApi);
;// CONCATENATED MODULE: ./src/services/greenCardApi.js














var GreenCardApi = /*#__PURE__*/function (_ServiceBase) {
  function GreenCardApi() {
    var _this;
    _classCallCheck(this, GreenCardApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, GreenCardApi, [].concat(args));
    _defineProperty(_this, "_origin", "greenCardApi");
    return _this;
  }
  _inherits(GreenCardApi, _ServiceBase);
  return _createClass(GreenCardApi, [{
    key: "_getGreenCardUrl",
    value: function _getGreenCardUrl(baseUrl, personId) {
      return "".concat(baseUrl, "/greenCard/status/").concat(personId);
    }
  }, {
    key: "_postScoreUrl",
    value: function _postScoreUrl(baseUrl) {
      return "".concat(baseUrl, "/greenCard/scores");
    }
  }, {
    key: "_approveGreenCardUrl",
    value: function _approveGreenCardUrl(baseUrl, personId) {
      return "".concat(baseUrl, "/greenCard/approve/").concat(personId);
    }
  }, {
    key: "getGreenCardStatus",
    value: function () {
      var _getGreenCardStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = this._getOptions(context);
              endpoint = this._getGreenCardUrl(options.baseUrl, payload.personId);
              setLoader(context, payload.personId, true, "Hämtar...", this._origin);
              _context.prev = 3;
              _context.next = 6;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "GET"
              }));
            case 6:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, payload.personId));
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              return _context.abrupt("return", this._processError(context, payload.personId, "Felaktigt anrop", 400));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 10]]);
      }));
      function getGreenCardStatus(_x, _x2) {
        return _getGreenCardStatus.apply(this, arguments);
      }
      return getGreenCardStatus;
    }()
  }, {
    key: "createScore",
    value: function () {
      var _createScore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : "createScore";
              options = this._getOptions(context);
              endpoint = this._postScoreUrl(options.baseUrl);
              setLoader(context, correlationId, true, "Sparar...", this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "POST",
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function createScore(_x3, _x4) {
        return _createScore.apply(this, arguments);
      }
      return createScore;
    }()
  }, {
    key: "approveGreenCard",
    value: function () {
      var _approveGreenCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : "approveGreenCard";
              options = this._getOptions(context);
              endpoint = this._approveGreenCardUrl(options.baseUrl, payload.personId);
              setLoader(context, correlationId, true, "Sparar...", this._origin);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: "POST",
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, "Felaktigt anrop", 400));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function approveGreenCard(_x5, _x6) {
        return _approveGreenCard.apply(this, arguments);
      }
      return approveGreenCard;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var greenCardApi = (GreenCardApi);
;// CONCATENATED MODULE: ./src/services/rentalItemApi.js














var RentalItemApi = /*#__PURE__*/function (_ServiceBase) {
  function RentalItemApi() {
    var _this;
    _classCallCheck(this, RentalItemApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RentalItemApi, [].concat(args));
    _defineProperty(_this, "_origin", 'rentalItemApi');
    return _this;
  }
  _inherits(RentalItemApi, _ServiceBase);
  return _createClass(RentalItemApi, [{
    key: "_getRentalItemUrl",
    value: function _getRentalItemUrl(baseUrl, courseId, teeTime, playerId) {
      var url = "".concat(baseUrl, "/Courses/").concat(courseId, "/RentalItems?teeTime=").concat(teeTime);
      if (playerId) url += "&playerId=".concat(playerId);
      return url;
    }
  }, {
    key: "_getRemoveItemBookingUrl",
    value: function _getRemoveItemBookingUrl(baseUrl, itemId) {
      return "".concat(baseUrl, "/ItemBookings/").concat(itemId);
    }
  }, {
    key: "_getCreateItemBookingUrl",
    value: function _getCreateItemBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/ItemBookings");
    }
  }, {
    key: "_getEditItemBookingUrl",
    value: function _getEditItemBookingUrl(baseUrl, itemId) {
      return "".concat(baseUrl, "/ItemBookings/").concat(itemId);
    }
  }, {
    key: "_getEditItemBookingsUrl",
    value: function _getEditItemBookingsUrl(baseUrl, slotBookingId) {
      return "".concat(baseUrl, "/Slotbookings/").concat(slotBookingId, "/ItemBookings");
    }
  }, {
    key: "getRentalItems",
    value: function () {
      var _getRentalItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.courseId;
              options = this._getOptions(context);
              endpoint = this._getRentalItemUrl(options.baseUrl, payload.courseId, payload.teeTime, payload.playerId);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getRentalItems(_x, _x2) {
        return _getRentalItems.apply(this, arguments);
      }
      return getRentalItems;
    }()
  }, {
    key: "removeItemBooking",
    value: function () {
      var _removeItemBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'removeItemBooking';
              options = this._getOptions(context);
              endpoint = this._getRemoveItemBookingUrl(options.baseUrl, payload);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'DELETE'
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function removeItemBooking(_x3, _x4) {
        return _removeItemBooking.apply(this, arguments);
      }
      return removeItemBooking;
    }()
  }, {
    key: "createItemBooking",
    value: function () {
      var _createItemBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'createItemBooking';
              options = this._getOptions(context);
              endpoint = this._getCreateItemBookingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context3.prev = 4;
              _context3.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function createItemBooking(_x5, _x6) {
        return _createItemBooking.apply(this, arguments);
      }
      return createItemBooking;
    }()
  }, {
    key: "editItemBooking",
    value: function () {
      var _editItemBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'editItemBooking';
              options = this._getOptions(context);
              endpoint = this._getEditItemBookingUrl(options.baseUrl, payload.itemId);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context4.prev = 4;
              _context4.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'PUT',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context4.sent;
              return _context4.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              return _context4.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 11]]);
      }));
      function editItemBooking(_x7, _x8) {
        return _editItemBooking.apply(this, arguments);
      }
      return editItemBooking;
    }()
  }, {
    key: "editItemBookings",
    value: function () {
      var _editItemBookings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'editItemBookings';
              options = this._getOptions(context);
              endpoint = this._getEditItemBookingsUrl(options.baseUrl, payload.slotBookingId);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context5.prev = 4;
              _context5.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'PUT',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context5.sent;
              return _context5.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](4);
              return _context5.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[4, 11]]);
      }));
      function editItemBookings(_x9, _x10) {
        return _editItemBookings.apply(this, arguments);
      }
      return editItemBookings;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var rentalItemApi = (RentalItemApi);
;// CONCATENATED MODULE: ./src/services/feeApi.js













var FeeApi = /*#__PURE__*/function (_ServiceBase) {
  function FeeApi() {
    var _this;
    _classCallCheck(this, FeeApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FeeApi, [].concat(args));
    _defineProperty(_this, "_origin", 'feeApi');
    return _this;
  }
  _inherits(FeeApi, _ServiceBase);
  return _createClass(FeeApi, [{
    key: "_getFeeUrl",
    value: function _getFeeUrl(baseUrl, slotBookingId) {
      var url = "".concat(baseUrl, "/Courses/SlotBookings/").concat(slotBookingId, "/Fees");
      return url;
    }
  }, {
    key: "_getCompanyUrl",
    value: function _getCompanyUrl(baseUrl, courseId, keyWord, slotTime) {
      var url = "".concat(baseUrl, "/Courses/").concat(courseId, "/CompanyGameRights/").concat(keyWord, "?slotTime=").concat(slotTime);
      return url;
    }
  }, {
    key: "getFees",
    value: function () {
      var _getFees = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getFees';
              options = this._getOptions(context);
              endpoint = this._getFeeUrl(options.baseUrl, payload.slotBookingId);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function getFees(_x, _x2) {
        return _getFees.apply(this, arguments);
      }
      return getFees;
    }()
  }, {
    key: "getCompany",
    value: function () {
      var _getCompany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getCompany';
              options = this._getOptions(context);
              endpoint = this._getCompanyUrl(options.baseUrl, payload.courseId, payload.keyWord, payload.slotTime);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function getCompany(_x3, _x4) {
        return _getCompany.apply(this, arguments);
      }
      return getCompany;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var feeApi = (FeeApi);
;// CONCATENATED MODULE: ./src/services/messagesApi.js













var MessagesApi = /*#__PURE__*/function (_ServiceBase) {
  function MessagesApi() {
    var _this;
    _classCallCheck(this, MessagesApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MessagesApi, [].concat(args));
    _defineProperty(_this, "_origin", 'messagesApi');
    return _this;
  }
  _inherits(MessagesApi, _ServiceBase);
  return _createClass(MessagesApi, [{
    key: "_getAppMessageUrl",
    value: function _getAppMessageUrl(baseUrl, appName) {
      return "".concat(baseUrl, "/messages/").concat(appName);
    }
  }, {
    key: "_getPostAppMessageUrl",
    value: function _getPostAppMessageUrl(baseUrl) {
      return "".concat(baseUrl, "/messages");
    }
  }, {
    key: "getMessage",
    value: function () {
      var _getMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, appName) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = "getMessage/".concat(appName);
              options = this._getOptions(context);
              endpoint = this._getAppMessageUrl(options.baseUrl, appName);
              _context.prev = 3;
              _context.next = 6;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 6:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 10]]);
      }));
      function getMessage(_x, _x2) {
        return _getMessage.apply(this, arguments);
      }
      return getMessage;
    }()
  }, {
    key: "deleteMessage",
    value: function () {
      var _deleteMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, appName) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = "getMessage/".concat(appName);
              options = this._getOptions(context);
              endpoint = this._getAppMessageUrl(options.baseUrl, appName);
              _context2.prev = 3;
              _context2.next = 6;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'DELETE'
              }));
            case 6:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 10]]);
      }));
      function deleteMessage(_x3, _x4) {
        return _deleteMessage.apply(this, arguments);
      }
      return deleteMessage;
    }()
  }, {
    key: "postMessage",
    value: function () {
      var _postMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, appMessage) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = appMessage.correlationId ? appMessage.correlationId : 'postMessage';
              options = this._getOptions(context);
              endpoint = this._getPostAppMessageUrl(options.baseUrl);
              _context3.prev = 3;
              _context3.next = 6;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(appMessage)
              }));
            case 6:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](3);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 10]]);
      }));
      function postMessage(_x5, _x6) {
        return _postMessage.apply(this, arguments);
      }
      return postMessage;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var messagesApi = (MessagesApi);
;// CONCATENATED MODULE: ./src/services/groupBookingApi.js














var GroupBookingApi = /*#__PURE__*/function (_ServiceBase) {
  function GroupBookingApi() {
    var _this;
    _classCallCheck(this, GroupBookingApi);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, GroupBookingApi, [].concat(args));
    _defineProperty(_this, "_origin", 'groupBookingApi');
    return _this;
  }
  _inherits(GroupBookingApi, _ServiceBase);
  return _createClass(GroupBookingApi, [{
    key: "_getEditGroupBookingUrl",
    value: function _getEditGroupBookingUrl(baseUrl, groupBookingId) {
      return "".concat(baseUrl, "/GroupBookings/").concat(groupBookingId);
    }
  }, {
    key: "_getGroupBookingUrl",
    value: function _getGroupBookingUrl(baseUrl, groupBookingId) {
      return "".concat(baseUrl, "/GroupBookings/").concat(groupBookingId);
    }
  }, {
    key: "_getMoveGroupBookingUrl",
    value: function _getMoveGroupBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/GroupBookings/Move");
    }
  }, {
    key: "_getValidateMoveGroupBookingUrl",
    value: function _getValidateMoveGroupBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/GroupBookings/Move/Validate");
    }
  }, {
    key: "_getExtendGroupBookingUrl",
    value: function _getExtendGroupBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/GroupBookings/Extend");
    }
  }, {
    key: "_getValidateExtendGroupBookingUrl",
    value: function _getValidateExtendGroupBookingUrl(baseUrl) {
      return "".concat(baseUrl, "/GroupBookings/Extend/Validate");
    }
  }, {
    key: "editGroupBooking",
    value: function () {
      var _editGroupBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'groupBooking';
              options = this._getOptions(context);
              endpoint = this._getEditGroupBookingUrl(options.baseUrl, payload.groupBookingId);
              setLoader(context, correlationId, true, 'Sparar...', this._origin);
              _context.prev = 4;
              _context.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'PUT',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context.sent;
              return _context.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              return _context.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 11]]);
      }));
      function editGroupBooking(_x, _x2) {
        return _editGroupBooking.apply(this, arguments);
      }
      return editGroupBooking;
    }()
  }, {
    key: "getGroupBooking",
    value: function () {
      var _getGroupBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'getGroupBooking';
              options = this._getOptions(context);
              endpoint = this._getGroupBookingUrl(options.baseUrl, payload.groupBookingId);
              setLoader(context, correlationId, true, 'Laddar...', this._origin);
              _context2.prev = 4;
              _context2.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'GET'
              }));
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 11]]);
      }));
      function getGroupBooking(_x3, _x4) {
        return _getGroupBooking.apply(this, arguments);
      }
      return getGroupBooking;
    }()
  }, {
    key: "moveGroupBooking",
    value: function () {
      var _moveGroupBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(context, payload) {
        var correlationId, options, endpoint, loaderMessage, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'moveGroupBooking';
              options = this._getOptions(context);
              endpoint = this._getMoveGroupBookingUrl(options.baseUrl);
              loaderMessage = 'Sparar...';
              setLoader(context, correlationId, true, loaderMessage, this._origin);
              _context3.prev = 5;
              _context3.next = 8;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 8:
              response = _context3.sent;
              return _context3.abrupt("return", this._processResponse(context, response, correlationId));
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](5);
              return _context3.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[5, 12]]);
      }));
      function moveGroupBooking(_x5, _x6) {
        return _moveGroupBooking.apply(this, arguments);
      }
      return moveGroupBooking;
    }()
  }, {
    key: "validateMoveGroupBooking",
    value: function () {
      var _validateMoveGroupBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'moveGroupBooking';
              options = this._getOptions(context);
              endpoint = this._getValidateMoveGroupBookingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context4.prev = 4;
              _context4.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context4.sent;
              return _context4.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](4);
              return _context4.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[4, 11]]);
      }));
      function validateMoveGroupBooking(_x7, _x8) {
        return _validateMoveGroupBooking.apply(this, arguments);
      }
      return validateMoveGroupBooking;
    }()
  }, {
    key: "extendGroupBooking",
    value: function () {
      var _extendGroupBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(context, payload) {
        var correlationId, options, endpoint, loaderMessage, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'extendGroupBooking';
              options = this._getOptions(context);
              endpoint = this._getExtendGroupBookingUrl(options.baseUrl);
              loaderMessage = 'Sparar...';
              setLoader(context, correlationId, true, loaderMessage, this._origin);
              _context5.prev = 5;
              _context5.next = 8;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 8:
              response = _context5.sent;
              return _context5.abrupt("return", this._processResponse(context, response, correlationId));
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](5);
              return _context5.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[5, 12]]);
      }));
      function extendGroupBooking(_x9, _x10) {
        return _extendGroupBooking.apply(this, arguments);
      }
      return extendGroupBooking;
    }()
  }, {
    key: "validateExtendGroupBooking",
    value: function () {
      var _validateExtendGroupBooking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(context, payload) {
        var correlationId, options, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              correlationId = payload.correlationId ? payload.correlationId : 'extendGroupBooking';
              options = this._getOptions(context);
              endpoint = this._getValidateExtendGroupBookingUrl(options.baseUrl);
              setLoader(context, correlationId, true, 'Validerar...', this._origin);
              _context6.prev = 4;
              _context6.next = 7;
              return fetch(endpoint, _objectSpread2(_objectSpread2({}, options), {}, {
                method: 'POST',
                body: JSON.stringify(payload)
              }));
            case 7:
              response = _context6.sent;
              return _context6.abrupt("return", this._processResponse(context, response, correlationId));
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](4);
              return _context6.abrupt("return", this._processError(context, correlationId, 'Felaktigt anrop', 400));
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[4, 11]]);
      }));
      function validateExtendGroupBooking(_x11, _x12) {
        return _validateExtendGroupBooking.apply(this, arguments);
      }
      return validateExtendGroupBooking;
    }()
  }]);
}(serviceBase);
/* harmony default export */ var groupBookingApi = (GroupBookingApi);
;// CONCATENATED MODULE: ./src/services/index.js




















;// CONCATENATED MODULE: ./src/index.js








;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=go-api-services.common.js.map